import { getTranslation } from "Utils/getTranslation"

// Utils
import { iconsFontAwesome } from "Utils/listIconFontAwesome"

// Design tokens
import { colors } from "Shared/tokens"

export const fontSizeOptions = [
  {
    value: "0.8rem",
    name: "8",
  },
  {
    value: "0.9rem",
    name: "9",
  },
  {
    value: "1rem",
    name: "10",
  },
  {
    value: "1.1rem",
    name: "11",
  },
  {
    value: "1.2rem",
    name: "12",
  },
  {
    value: "1.4rem",
    name: "14",
  },
  {
    value: "1.6rem",
    name: "16",
  },
  {
    value: "1.8rem",
    name: "18",
  }, // les options si dessous on été supprimé mais certain widget on été configuré avec et ne match plus côté affichage de la valeur
  {
    value: "2rem",
    name: "20",
  },
  {
    value: "2.2rem",
    name: "22",
  },
  {
    value: "2.4rem",
    name: "24",
  },
  {
    value: "2.6rem",
    name: "26",
  },
  {
    value: "2.8rem",
    name: "28",
  },
  {
    value: "3.6rem",
    name: "36",
  },
]

export const fontSizeNumberOptions = [
  {
    value: 0.8,
    name: "8",
  },
  {
    value: 0.9,
    name: "9",
  },
  {
    value: 1,
    name: "10",
  },
  {
    value: 1.1,
    name: "11",
  },
  {
    value: 1.2,
    name: "12",
  },
  {
    value: 1.4,
    name: "14",
  },
  {
    value: 1.6,
    name: "16",
  },
  {
    value: 1.8,
    name: "18",
  },
  {
    value: 2,
    name: "20",
  },
  {
    value: 2.4,
    name: "24",
  },
  {
    value: 2.6,
    name: "26",
  },
  {
    value: 2.8,
    name: "28",
  },
  {
    value: 3.6,
    name: "36",
  },
]

export const configurationType = {
  SELECT: "select",
  INPUT: "input",
  TOGGLE: "toggle",
  FULL_TEXT_COLOR_PARAM: "fullTextColorInput",
  FULL_TEXT_PARAM: "fullTextInput",
  COLOR_SELECTOR: "colorSelector",
  ICON_SELECT: "iconSelect",
  TEXT_AREA: "textArea",
  SELECT_ICON: "selectIcon",
  SELECT_ICONS: "selectIcons",
  PAGE_SELECT: "pageSelect",
  PAGE_REFERENTIEL: "pageReferentiel",
  PHOTO_INPUT: "photoInput",
  LOCATION_INPUT: "locationInput",
  GOOGLE_MAP_ICONS: "googleMapIcons",
  GOOGLE_MAP_LAYER: "googleMapLayer",
  RANGES: "ranges",
  COLOR_MAPPER: "colorMapper",
  REFERENTIAL_SIMPLE_SELECT: "referentialSimpleSelect",
  REFERENTIAL_PROPERTIES_SELECT: "referentialPropertiesSelect",
}

/**
 * @description Get widget configuration
 */
export const getAvailableWidgetConfiguration = (widgetType, chartVariant = "") => {
  let chartName

  if (widgetType === "pieChart" && chartVariant !== "") chartName = chartVariant
  else chartName = widgetType

  switch (chartName) {
    case "pieChart":
    case "semiPieChart":
      return [
        "categoryPieChartColorText",
        "categoryPieChartExportMenu",
        "categoryPieChartCentralText",
        "categoryPieChartExternalLabel",
        "categoryPieChartLegend",
        "categoryPieChartValues",
        "categoryPieChartAdvancedStyle",
        "categoryWidgetShape",
      ]
    case "doublePieChart":
    case "doubleSemiPieChart":
      return [
        "categoryPieChartColorText",
        "categoryPieChartExportMenu",
        "categoryPieChartCentralText",
        "categoryPieChartExternalLabel",
        "categoryPieChartLegend",
        "categoryDoublePieChartValues",
        "categoryDoublePieChartAdvancedStyle",
        "categoryWidgetShape",
      ]
    case "dropdownList":
      return [
        "placeholder",
        "categoryDropdownBehavior",
        "categoryDropdownColorText",
        "categoryDropdownWidgetShape",
      ]
    case "rangeFilter":
      return ["placeholder", "categoryDropdownColorText", "categoryRangeFilterWidgetShape"]
    case "searchBar":
      return ["placeholder", "categorySearchBarBehavior", "categoryDropdownColorText", "categorySearchBarWidgetShape"]
    case "hierarchicalFilter":
      return ["placeholder", "categoryDropdownColorText", "categoryDropdownWidgetShape"]
    case "calendar":
      return ["placeholder", "categorCalendarColorText", "categoryCalendarWidgetShape"]
    case "cumulativeLineChart":
    case "lineChart":
    case "stackedArea":
      return [
        "categoryLineChartColorText",
        "categoryLineChartExportMenu",
        "categoryLineChartAxis",
        "categoryLineChartLegend",
        "categoryLineChartGrid",
        "categoryLineChartValues",
        "categoryLineChartAdvancedStyle",
        "categoryWidgetShape",

        // "useLogarithm",
      ]
    case "counter":
      return [
        "label",
        "widgetDescription",
        "iconSelected",
        "categoryCounterColorText",
        "categoryCounterValues",
        "categoryCounterWidgetShape",
        "categoryCounterExportMenu",
      ]
    case "caseCardMSF":
      return ["categoryCounterWidgetShape"]
    case "gaugeChart":
      return [
        "categoryGaugeColorText",
        "categoryGaugeExportFullSize",
        "categoryGaugeLegend",
        "categoryGaugeValues",
        "categoryGaugeAdvancedStyle",
        "categoryWidgetShape",
        // "clockHandTooltipBeforeValue",
        // "clockHandTooltipAfterValue",
      ]
    case "histogram":
    case "stackedBar":
    case "pyramide":
    case "horizontalBarChart":
      return [
        "categoryHistogramColorText",
        "categoryHistogramExportMenu",
        "categoryHistogramAxis",
        "categoryHistogramLegend",
        "categoryHistogramGrid",
        "categoryHistogramValues",
        "categoryTooltip",
        "categoryHistogramAdvancedStyle",
        "categoryWidgetShape",
      ]
    case "table":
      return [
        "categoryTableColorText",
        "categoryTableExportMenu",
        "categoryTableGrid",
        "categoryTableValues",
        "categoryTableAdvancedStyle",
        "categoryWidgetShape",
      ]
    case "ag_table":
      return [
        "categoryImageColorText",
        "categoryExportMenu",
        "categoryTableValues",
        "categoryAgTableFeatures",
        "categoryAgTableAdvancedStyle",
        "categoryWidgetShape",
      ]
    case "radarChart":
      return [
        "categoryRadarColorText",
        "categoryRadarExportMenu",
        "categoryRadarAxis",
        "categoryRadarLegend",
        "categoryRadarValue",
        "categoryRadarAdvancedStyle",
        "categoryWidgetShape",
      ]
    case "mapping":
      return [
        "mapChoice",
        "mapVue",
        "categoryMapColorText",
        "categoryMapValue",
        "categoryMapExportMenu",
        "categoryMapLegend",
        "categoryMapAdvancedStyle",
        "categoryWidgetShape",
      ]
    case "mappingFilter":
      return [
        "mapChoice",
        "categoryMapExportMenu",
        "categoryMapAdvancedStyle",
        "categoryWidgetShape",
      ]
    case "basicText":
      return ["basicTextTextArea", "categoryBasicTextColorText", "categoryBasicTextWidgetShape"]
    case "actualityList":
      return ["categoryBasicTextColorText", "categoryBasicTextWidgetShape"]
    case "redirectButton":
      return [
        "label",
        "redirectButtonUrl",
        "redirectButtonUrlPage",
        "redirectButtonReferentiel",
        "categoryRedirectButtonColorText",
        "categoryRedirectButtonWidgetShape",
      ]
    case "progressBar":
      return [
        "categoryProgressBar",
        "categoryProgressBarLabel",
        "categoryProgressBarLegend",
        "categoryProgressBarValue",
        "categoryTooltip",
        "categoryProgressBarExportMenu",
        "categoryWidgetShape",
      ]
    case "ganttChartV2":
      return [
        "categoryHistogramColorText",
        "categoryExportMenu",
        "categoryGanttDisplay",
        "categoryWidgetShape",
      ]
    case "image":
      return ["categoryImageImage", "categoryImageColorText", "categoryImageWidgetShape"]
    case "treeMap":
      return [
        "categoryTreeMapColorText",
        "categoryTreeMapLegend",
        "categoryTreeMapExportMenu",
        "categoryTreeMapValue",
        "categoryTreeMapAdvancedStyle",
        "categoryWidgetShape",
      ]
    case "multiGauge":
      return [
        "anglePresets",
        "categoryColorText",
        "categoryExportMenu",
        "categoryLegend",
        "categoryMultiGaugeValue",
        "categoryMultiGaugeAdvancedStyle",
        "categoryWidgetShape",
      ]
    case "evolutionWidget":
      return [
        "categoryEvolutionColorText",
        "categoryEvolutionValue",
        "categoryEvolutionAdvancedValue",
        "categoryWidgetShape",
      ]
    case "heatMap":
      return [
        "categoryHeatMapColorText",
        "categoryExportMenu",
        "categoryHeatMapLegend",
        "categoryHeatMapValue",
      ]
    case "heatMapRisk":
      return [
        "categoryHeatMapColorText",
        "categoryHeatMapAxis",
        "categoryExportMenu",
        "categoryHeatMapLegend",
      ]
    case "bubbleChart":
      return [
        "categoryBubbleChartColorText",
        "categoryBubbleChartExportMenu",
        "categoryBubbleChartAxis",
        "categoryBubbleChartGrid",
        "categoryBubbleChartLegend",
        "categoryBubbleChartValues",
        "categoryBubbleChartAdvancedStyle",
        "categoryWidgetShape",
      ]
    case "cloudWords":
      return [
        "categoryCloudWordsColorText",
        "categoryExportMenu",
        "categoryCloudWordsValue",
        "categoryWidgetShape",
      ]
    case "fillingGauge":
      return ["categoryColorText", "categoryTableAdvancedStyle", "categoryCalendarWidgetShape"]
    case "googleMap":
      return [
        "centerGoogleMap",
        "themeGoogleMap",
        "useMarker",
        "useMarkerCluster",
        "markersGoogleMapSelectIcons",
        "categoryCounterWidgetShape",
        "categoryMapExportMenu",
        "googleMapLayer",
      ]
    case "lastSampleWidget":
      return [
        "lastSampleReferentialId",
        "lastSampleProperties",
        "categoryWidgetShape",
      ]
    case "actuality":
      return ["backgroundColor"]
    case "pipeline":
      return []
    default:
      return []
  }
}

/**
 * @description Get widget CATEGORY AND INPUTS configuration
 */
export const getConfigurationDetail = (propsName, langageId = 1, options) => {
  const trad = getTranslation(langageId) || {}

  switch (propsName) {
    case "label":
      return {
        label: trad.LABEL, //add translation here
        propsName: "label",
        type: configurationType.INPUT,
        dataType: "text",
        showIcon: false,
      }
    case "googleMapLayer":
      return {
        label: "Layer",
        propsName: "geoJsonFileId",
        type: configurationType.GOOGLE_MAP_LAYER,
        dataType: "text",
        showIcon: false,
      }
    case "valueStyle":
      return {
        label: trad.VALUE,
        propsName: "valeur",
        colorPropsName: "fontColor",
        firstSelectPropsName: "fontSize",
        secondSelectPropsName: "fontWeight",
        firstSelectLabel: "Taille :",
        secondSelectLabel: "Style :",
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        useColorOpacity: true,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "bold",
            name: "bold",
          },
        ],
      }
    case "labelStyle":
      return {
        label: trad.LABEL,
        propsName: "labelColor",
        colorPropsName: "labelColor",
        firstSelectPropsName: "labelSize",
        secondSelectPropsName: "labelWeight",
        firstSelectLabel: "Taille :",
        secondSelectLabel: "Style :",
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
      }
    case "titleStyle":
      return {
        label: trad.TITLE_STYLE,
        propsName: "titleStyle",
        colorPropsName: "titleColor",
        firstSelectPropsName: "titleSize",
        secondSelectPropsName: "titleWeight",
        firstSelectLabel: `${trad.SIZE} :`,
        secondSelectLabel: `${trad.STYLE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        useColorOpacity: true,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
      }
    case "backgroundColor":
      return {
        label: trad.BACKGROUND,
        propsName: "backgroundColor",
        colorPropsName: "backgroundColor",
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        activationPropsName: "activeBackground",
        withActivation: true,
        defaultValue: "#ffffffFF",
        activationDefaultProps: false,
        useColorOpacity: true,
      }
    case "bordureStyle":
      return {
        label: trad.BORDER,
        propsName: "bordureStyle",
        colorPropsName: "borderColor",
        firstSelectPropsName: "borderSize",
        secondSelectPropsName: "borderStyle",
        firstSelectLabel: trad.THICKNESS + " :",
        secondSelectLabel: trad.STYLE + " :",
        withActivation: true,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        activationPropsName: "activeBorder",
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: false,
        useColorOpacity: true,
        firstSelectOptions: [
          {
            value: "1px",
            name: "1px",
          },
          {
            value: "2px",
            name: "2px",
          },
          {
            value: "3px",
            name: "3px",
          },
          {
            value: "4px",
            name: "4px",
          },
          {
            value: "5px",
            name: "5px",
          },
        ],
        secondSelectOptions: [
          {
            value: "solid",
            name: "solid",
          },
          {
            value: "dotted",
            name: "dotted",
          },
          {
            value: "dashed",
            name: "dashed",
          },
          {
            value: "groove",
            name: "groove",
          },
          {
            value: "ridge",
            name: "ridge",
          },
          {
            value: "inset",
            name: "inset",
          },
          {
            value: "outset",
            name: "outset",
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1px",
            name: "1px",
          },
        ],
        secondDefaultProps: [
          {
            value: "solid",
            name: "solid",
          },
        ],
      }
    case "titleAlignement":
      return {
        label: trad.TITLE_ALIGNMENT,
        propsName: "titleAlignement",
        type: configurationType.ICON_SELECT,
        defaultValue: false,
        withIcon: true,
        activationDefaultProps: true,
        icon: "alignementIcon",
        options: [
          {
            value: "left",
            name: trad.LEFT,
          },
          {
            value: "center",
            name: trad.CENTERED,
          },
        ],
        defaultValue: [
          {
            value: "left",
            name: trad.LEFT,
          },
        ],
      }
    case "bodyTableAlignement":
      return {
        label: trad.TEXT_ALIGNMENT_IN_COLUMNS,
        propsName: "bodyTableAlignement",
        type: configurationType.SELECT,
        options: [
          {
            value: "left",
            name: trad.LEFT,
          },
          {
            value: "center",
            name: trad.CENTERED,
          },
          {
            value: "right",
            name: trad.RIGHT,
          },
        ],
        defaultValue: "center",
      }
    case "alignement":
      return {
        label: trad.ALIGNMENT,
        propsName: "fontAlignement",
        type: configurationType.ICON_SELECT,
        defaultValue: false,
        withIcon: true,
        activationDefaultProps: true,
        icon: "alignementIcon",
        options: [
          {
            value: "flex-start",
            name: trad.LEFT,
          },
          {
            value: "center",
            name: trad.CENTERED,
          },
          {
            value: "flex-end",
            name: trad.RIGHT,
          },
        ],
        defaultValue: [
          {
            value: "center",
            name: trad.CENTERED,
          },
        ],
      }
    case "borderRadius":
      var options = []
      for (let i = 0; i <= 20; i++) {
        options.push({
          value: `${i}px`,
          name: `${i}px`,
        })
      }
      return {
        label: trad.ANGLES,
        propsName: "borderRadius",
        type: configurationType.ICON_SELECT,
        activationPropsName: "activeRadius",
        withActivation: true,
        defaultValue: false,
        withIcon: true,
        icon: "borderRadiusIcon",
        activationDefaultProps: false,
        defaultValue: [
          {
            value: "10px",
            name: "10px",
          },
        ],
        options: options,
      }
    case "columnCornerRadiusTopLeft":
      return {
        label: trad.ROUNDING_UPPER_LEFT_CORNER_COLUMN,
        propsName: "columnCornerRadiusTopLeft",
        type: configurationType.INPUT,
        defaultValue: 4,
        dataType: "number",
        showIcon: false,
      }
    case "serieRadius":
      return {
        label: trad.ROUNDING_SERIES,
        propsName: "serieRadius",
        type: configurationType.INPUT,
        defaultValue: 4,
        dataType: "number",
        showIcon: false,
      }
    case "columnCornerRadiusTopRight":
      return {
        label: trad.ROUNDING_UPPER_RIGHT_CORNER_COLUMN,
        propsName: "columnCornerRadiusTopRight",
        type: configurationType.INPUT,
        defaultValue: 4,
        dataType: "number",
        showIcon: false,
      }
    case "columnCornerRadiusBottomLeft":
      return {
        label: trad.ROUNDING_LOWER_LEFT_CORNER_COLUMN,
        propsName: "columnCornerRadiusBottomLeft",
        type: configurationType.INPUT,
        defaultValue: 0,
        dataType: "number",
        showIcon: false,
      }
    case "columnCornerRadiusBottomRight":
      return {
        label: trad.ROUNDING_LOWER_RIGHT_CORNER_COLUMN,
        propsName: "columnCornerRadiusBottomRight",
        type: configurationType.INPUT,
        defaultValue: 0,
        dataType: "number",
        showIcon: false,
      }
    case "columnsWidthPercent":
      return {
        label: trad.COLUMN_WIDTH,
        propsName: "columnsWidthPercent",
        type: configurationType.INPUT,
        defaultValue: 70,
        dataType: "number",
        showIcon: false,
      }
    case "themeStyle":
      return {
        label: trad.STYLE,
        propsName: "themeStyle",
        type: configurationType.SELECT,
        defaultValue: "defaultStyle",
        options: [
          {
            value: "customStyle",
            name: trad.CUSTOM_STYLE,
          },
          {
            value: "defaultStyle",
            name: trad.DEFAULT_STYLE,
          },
        ],
      }
    case "innerRadius":
      return {
        label: trad.INNER_RADIUS,
        propsName: "innerRadius",
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: false,
        defaultValue: 50,
        min: 0,
        max: 100,
      }
    case "showMenu":
      return {
        label: trad.SHOW_MENU,
        propsName: "showMenu",
        type: configurationType.TOGGLE,
        defaultValue: true,
      }
    // Camembert à une seule catégorie : complète la part manquante jusqu'à 100 % avec une
    // tranche neutre (rendu « jauge »). Pertinent pour un pourcentage, absurde pour un
    // compteur. true = comportement historique, donc les widgets déjà en base (qui n'ont
    // pas la clé) gardent leur rendu.
    case "pieChartGaugeMode":
      return {
        label: trad.PIE_GAUGE_MODE,
        propsName: "pieChartGaugeMode",
        type: configurationType.TOGGLE,
        defaultValue: true,
      }
    case "hideLabelIfPercentTooSmall":
      return {
        label: trad.HIDE_LABEL_INFERIOR_TO_A_VALUE,
        propsName: "hideLabelIfPercentTooSmall",
        type: configurationType.TOGGLE,
        defaultValue: true,
      }
    case "valuePercentUnderWhichHideLabel":
      return {
        label: trad.VALUE_UNDER_WHICH_TO_HIDE_LABELS,
        propsName: "valuePercentUnderWhichHideLabel",
        isConditionnal: {
          dependsOn: "hideLabelIfPercentTooSmall",
          value: true,
        },
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: true,
        defaultValue: 5,
        showIcon: false,
        min: 0,
        max: "none",
      }
    case "radarHideLabelIfPercentTooSmall":
      return {
        label: trad.HIDE_LABEL_INFERIOR_TO_A_VALUE,
        propsName: "hideLabelIfPercentTooSmall",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "radarValuePercentUnderWhichHideLabel":
      return {
        label: trad.VALUE_UNDER_WHICH_TO_HIDE_LABELS,
        propsName: "valuePercentUnderWhichHideLabel",
        isConditionnal: {
          dependsOn: "hideLabelIfPercentTooSmall",
          value: true,
        },
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: true,
        defaultValue: 50,
        showIcon: false,
        min: 0,
        max: "none",
      }
    case "visibilityLegend":
      return {
        label: trad.SHOW_LEGEND,
        propsName: "visibilityLegend",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "displayTypeLegendLabels":
      return {
        label: trad.LEGEND_LABEL_DISPLAY_TYPE,
        propsName: "displayTypeLegendLabels",
        isConditionnal: {
          dependsOn: "visibilityLegend",
          value: true,
        },
        type: configurationType.SELECT,
        defaultValue: "truncate",
        options: [
          {
            value: "truncate",
            name: trad.TRUNCATE,
          },
          {
            value: "wrap",
            name: trad.WRAP,
          },
        ],
      }
    case "legendPosition":
      return {
        label: trad.LEGEND_POSITION,
        propsName: "legendPosition",
        isConditionnal: {
          dependsOn: "visibilityLegend",
          value: true,
        },
        type: configurationType.SELECT,
        defaultValue: "right",
        options: [
          {
            value: "top",
            name: trad.TOP,
          },
          {
            value: "bottom",
            name: trad.BOTTOM,
          },
          {
            value: "left",
            name: trad.LEFT,
          },
          {
            value: "right",
            name: trad.RIGHT,
          },
        ],
      }
    case "placeholder":
      return {
        label: trad.PLACEHOLDER,
        propsName: "placeholder",
        type: configurationType.INPUT,
        defaultValue: "Search ... ",
        showIcon: false,
      }
    case "filterType":
      return {
        label: trad.FILTER_TYPE,
        propsName: "filterType",
        type: configurationType.SELECT,
        defaultValue: "right",
        options: [
          {
            value: "singleSelect",
            name: trad.UNIQUE_SELECTION_LIST,
          },
          {
            value: "multiSelect",
            name: trad.MULTIPLE_SELECTION_LIST,
          },
        ],
      }
    case "dateSelectionType":
      return {
        label: trad.SELECTION_TYPE,
        propsName: "onlyOneDate",
        type: configurationType.SELECT,
        defaultValue: false,
        options: [
          {
            value: false,
            name: trad.PERIOD,
          },
          {
            value: true,
            name: trad.ONLY_ONE_DATE,
          },
        ],
      }
    case "displayPeriod":
      return {
        label: trad.DISPLAY_PERIOD,
        propsName: "type",
        type: configurationType.SELECT,
        defaultValue: "day",
        options: [
          {
            value: "day",
            name: trad.DAY,
          },
          {
            value: "month",
            name: trad.MONTH,
          },
          {
            value: "trimester",
            name: trad.TRIMESTER,
          },
          {
            value: "semester",
            name: trad.SEMESTER,
          },
          {
            value: "year",
            name: trad.YEAR,
          },
        ],
      }
    case "enableFilters":
      return {
        label: trad.SEARCH_BY_COLUMN,
        propsName: "enableFilters",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "enableColumnsSumFooter":
      return {
        label: trad.ENABLE_COLUMNS_TOTAL,
        propsName: "enableColumnsSumFooter",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "enableExportMenu":
      return {
        label: trad.SHOW_EXPORT_MENU,
        propsName: "enableExportMenu",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "enableFullScreen":
      return {
        label: trad.SHOW_FULLSCREEN,
        propsName: "isFullScreenable",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "titleAxeX":
      return {
        label: trad.TITLE_AXE_X,
        propsName: "titleAxeX",
        type: configurationType.INPUT,
        defaultValue: trad.TITLE_AXE_X,
        showIcon: false,
      }
    case "titleAxeY":
      return {
        label: trad.TITLE_AXE_Y,
        propsName: "titleAxeY",
        type: configurationType.INPUT,
        defaultValue: trad.TITLE_AXE_Y,
        showIcon: false,
      }
    case "sizeBullet":
      return {
        label: trad.BULLET_SIZE,
        propsName: "sizeBullet",
        type: configurationType.INPUT,
        showIcon: false,
        defaultValue: 5,
        dataType: "number",
        useMinMax: true,
        min: 0,
        max: 10,
      }
    case "strokeWidthLine":
      return {
        label: trad.CURVE_THICKNESS,
        propsName: "strokeWidthLine",
        type: configurationType.INPUT,
        showIcon: false,
        defaultValue: 5,
        dataType: "number",
        useMinMax: true,
        min: 0,
        max: 10,
      }
    case "useLogarithm":
      return {
        label: trad.LOGARITHMIC_VIEW,
        propsName: "useLogarithm",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "lineStyle":
      return {
        label: trad.CURVE_STYLE,
        propsName: "lineStyle",
        type: configurationType.SELECT,
        defaultValue: "solid",
        options: [
          {
            value: "solid",
            name: trad.SOLID,
          },
          {
            value: "dashed",
            name: trad.DASHED,
          },
          {
            value: "dotted",
            name: trad.DOTTED,
          },
        ],
      }
    case "formCurve":
      return {
        label: trad.TYPE_OF_PLOT,
        propsName: "formCurve",
        type: configurationType.SELECT,
        defaultValue: 0.8,
        options: [
          {
            value: 0.8,
            name: trad.CURVE_LINE,
          },
          {
            value: 1,
            name: trad.STRAIGHT_LINE,
          },
        ],
      }
    case "fillOpacityCurve":
      return {
        label: trad.OPACITY_UNDER_THE_CURVE,
        propsName: "fillOpacityCurve",
        type: configurationType.INPUT,
        showIcon: false,
        defaultValue: 0.1,
        dataType: "number",
        useMinMax: true,
        min: 0,
        max: 1,
        step: 0.1,
      }
    case "disabledGridAxesX":
      return {
        label: trad.HIDE_GRID_HORIZONTALY,
        propsName: "disabledGridAxesX",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "disabledGridAxesY":
      return {
        label: trad.HIDE_GRID_VERTICALY,
        propsName: "disabledGridAxesY",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "startAngle":
      return {
        label: trad.START_ANGLE,
        propsName: "startAngle",
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: false,
        defaultValue: 0,
        min: -360,
        max: 360,
      }
    case "endAngle":
      return {
        label: trad.END_ANGLE,
        propsName: "endAngle",
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: false,
        defaultValue: 360,
        min: -360,
        max: 360,
      }
    case "showGrid":
      return {
        label: trad.SHOW_GRID,
        propsName: "showGrid",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "minGridDistance":
      return {
        label: trad.MINIMUM_DISTANCE_BETWEEN_GRID_LINES,
        propsName: "minGridDistance",
        isConditionnal: {
          dependsOn: "showGrid",
          value: true,
        },
        type: configurationType.INPUT,
        dataType: "number",
        defaultValue: 50,
        min: 0,
        max: 1000,
      }
    case "showOnlyMinMaxLabel":
      return {
        label: trad.SHOW_ONLY_MIN_AND_MAX,
        propsName: "showOnlyMinMaxLabel",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "showAxisLabel":
      return {
        label: trad.SHOW_LABEL,
        propsName: "showAxisLabel",
        isConditionnal: {
          dependsOn: "showOnlyMinMaxLabel",
          value: false,
        },
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "defaultColor":
      return {
        label: trad.DEFAULT_COLOR,
        propsName: "defaultColor",
        type: configurationType.COLOR_SELECTOR,
        defaultValue: options.sideMenuColor,
        useColorOpacity: true,
      }
    case "sliderColor":
      return {
        label: trad.SLIDER_COLOR,
        propsName: "sliderColor",
        type: configurationType.COLOR_SELECTOR,
        defaultValue: options.sideMenuColor,
      }
    case "headBackgroundColor":
      return {
        label: trad.HEADER_COLOR,
        propsName: "headBackgroundColor",
        type: configurationType.COLOR_SELECTOR,
        defaultValue: "#01014B",
        useColorOpacity: true,
      }
    case "headFontSize":
      return {
        label: trad.HEADER_FONT_SIZE,
        propsName: "headFontSize",
        type: configurationType.SELECT,
        defaultValue: "1rem",
        options: fontSizeOptions,
      }
    case "headColor":
      return {
        label: trad.HEADER_TEXT_COLOR,
        propsName: "headColor",
        type: configurationType.COLOR_SELECTOR,
        defaultValue: "#333",
      }
    case "displayHeadCellSeparator":
      return {
        label: trad.DISPLAY_HEAD_CELL_SEPARATOR,
        propsName: "displayHeadCellSeparator",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "displayBodyRowSeparator":
      return {
        label: trad.DISPLAY_LINE_SEPARATOR,
        propsName: "displayBodyRowSeparator",
        type: configurationType.TOGGLE,
        defaultValue: true,
      }
    case "displayBodyCellSeparator":
      return {
        label: trad.DISPLAY_COLUMN_SEPARATOR,
        propsName: "displayBodyCellSeparator",
        type: configurationType.TOGGLE,
        defaultValue: true,
      }
    case "headCellJustifyContent":
      return {
        label: trad.TEXT_ALIGNMENT_IN_THE_HEADER,
        propsName: "headCellJustifyContent",
        type: configurationType.SELECT,
        defaultValue: "center",
        options: [
          {
            value: "center",
            name: trad.CENTERED,
          },
          {
            value: "flex-end",
            name: trad.RIGHT,
          },
          {
            value: "flex-start",
            name: trad.LEFT,
          },
        ],
      }
    case "bodyCellJustifyContent":
      return {
        label: trad.TEXT_ALIGNMENT_IN_COLUMNS,
        propsName: "bodyCellJustifyContent",
        type: configurationType.SELECT,
        defaultValue: "center",
        options: [
          {
            value: "center",
            name: trad.CENTERED,
          },
          {
            value: "flex-end",
            name: trad.RIGHT,
          },
          {
            value: "flex-start",
            name: trad.LEFT,
          },
        ],
      }
    case "minAxesYtoZero":
      return {
        label: trad.DISPLAY_VALUE_TO_ZERO,
        propsName: "extraMinAxesY",
        type: configurationType.SELECT,
        defaultValue: 0,
        options: [
          {
            value: 0,
            name: trad.YES,
          },
          {
            value: 0.1,
            name: trad.NO,
          },
        ],
      }
    case "toogleMinMaxYAxis":
      return {
        label: trad.DELIMITED_AXIS_Y_VALUE,
        propsName: "useMinMaxYAxis",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "minYAxis":
      return {
        isConditionnal: {
          dependsOn: "useMinMaxYAxis",
          value: true,
        },
        label: trad.MIN,
        propsName: "minYAxis",
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: false,
        defaultValue: 0,
        min: 0,
      }
    case "maxYAxis":
      return {
        isConditionnal: {
          dependsOn: "useMinMaxYAxis",
          value: true,
        },
        label: trad.MAX,
        propsName: "maxYAxis",
        type: configurationType.INPUT,
        defaultValue: false,
        dataType: "number",
        useMinMax: false,
        defaultValue: 0,
        min: 0,
      }
    case "enableFooters":
      return {
        label: trad.SHOW_TOTALS,
        propsName: "enableFooters",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "footBackgroundColor":
      return {
        label: trad.FOOTER_COLOR,
        propsName: "footBackgroundColor",
        isConditionnal: {
          dependsOn: "enableFooters",
          value: true,
        },
        type: configurationType.COLOR_SELECTOR,
        defaultValue: "#fff",
      }
    case "footColor":
      return {
        label: trad.FOOTER_TEXT_COLOR,
        propsName: "footColor",
        isConditionnal: {
          dependsOn: "enableFooters",
          value: true,
        },
        type: configurationType.COLOR_SELECTOR,
        defaultValue: "#000",
      }
    case "footCellAlignItems":
      return {
        label: trad.TEXT_ALIGNMENT_IN_THE_FOOTER,
        propsName: "footCellAlignItems",
        isConditionnal: {
          dependsOn: "enableFooters",
          value: true,
        },
        type: configurationType.SELECT,
        defaultValue: "center",
        options: [
          {
            value: "center",
            name: trad.CENTERED,
          },
          {
            value: "flex-end",
            name: trad.RIGHT,
          },
          {
            value: "flex-start",
            name: trad.LEFT,
          },
        ],
      }
    case "enablePagination":
      return {
        label: trad.ADD_A_PAGINATION,
        propsName: "enablePagination",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "nbRowsPerPage":
      return {
        label: trad.NB_LINES_PER_PAGE,
        propsName: "nbRowsPerPage",
        type: configurationType.SELECT,
        isConditionnal: {
          dependsOn: "enablePagination",
          value: true,
        },
        dataType: "number",
        defaultValue: 100,
        options: [
          {
            value: 10,
            name: `10 / ${trad.PAGE}`,
          },
          {
            value: 25,
            name: `25 / ${trad.PAGE}`,
          },
          {
            value: 50,
            name: `50 / ${trad.PAGE}`,
          },
          {
            value: 100,
            name: `100 / ${trad.PAGE}`,
          },
        ],
      }
    case "paginationColor":
      return {
        label: trad.PAGINATION_COLOR,
        propsName: "paginationColor",
        isConditionnal: {
          dependsOn: "enablePagination",
          value: true,
        },
        type: configurationType.COLOR_SELECTOR,
        defaultValue: "#7F7F7F",
      }
    case "colorMapper":
      return {
        label: trad.COLOR_BY_VALUE,
        propsName: "colorMapper",
        type: configurationType.COLOR_MAPPER,
        defaultValue: [],
      }
    case "ganttSidebarWidthPercent":
      return {
        label: trad.GANTT_SIDEBAR_WIDTH,
        propsName: "ganttSidebarWidthPercent",
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: true,
        defaultValue: 30,
        showIcon: false,
        min: 10,
        max: 70,
      }
    case "ganttDurationUnit":
      return {
        label: trad.GANTT_DURATION_UNIT,
        propsName: "ganttDurationUnit",
        type: configurationType.SELECT,
        defaultValue: "day",
        options: [
          {
            value: "day",
            name: trad.DAY,
          },
          {
            value: "week",
            name: trad.WEEK,
          },
          {
            value: "month",
            name: trad.MONTH,
          },
        ],
      }
    case "ganttExcludeWeekends":
      return {
        label: trad.GANTT_EXCLUDE_WEEKENDS,
        propsName: "ganttExcludeWeekends",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "colorSetThemeName":
      return {
        label: trad.CHOOSE_YOUR_COLOR_THEME,
        propsName: "colorSetThemeName",
        type: configurationType.SELECT,
        defaultValue: options?.defaultColorPalette,
        options: options?.listColors,
      }
    case "numberDecimal":
      return {
        label: trad.DECIMAL_NUMBER,
        propsName: "numberDecimal",
        type: configurationType.SELECT,
        dataType: "number",
        defaultValue: 0,
        options: [0, 1, 2, 3].map(number => ({
          value: number,
          name: `${number}`,
        })),
      }
    case "showSpaceForThousand":
      return {
        label: trad.THOUSAND_SEPARATOR,
        propsName: "showSpaceForThousand",
        type: configurationType.TOGGLE,
        defaultValue: true,
      }
    case "showSpaceForThousandProgressBar":
      return {
        label: trad.THOUSAND_SEPARATOR,
        propsName: "showSpaceForThousand",
        type: configurationType.TOGGLE,
        defaultValue: true,
        isConditionnal: {
          dependsOn: "typeValue",
          value: ["value", "value_and_percent", "percent_and_value"],
        },
      }
    case "decimalSeparator":
      return {
        label: trad.DECIMAL_SEPARATOR,
        propsName: "decimalSeparator",
        type: configurationType.SELECT,
        defaultValue: ",",
        options: [
          {
            value: ",",
            name: trad.COMMA_OPTION,
          },
          {
            value: ".",
            name: trad.DOT_OPTION,
          },
        ],
      }
    case "showClockHand":
      return {
        label: trad.SHOW_CLOCK_HAND,
        propsName: "showClockHand",
        type: configurationType.TOGGLE,
        defaultValue: true,
      }
    case "zoomButtons":
      return {
        label: trad.ZOOM_BUTTONS,
        propsName: "zoomButtons",
        type: configurationType.TOGGLE,
        defaultValue: false,
        isConditionnal: {
          dependsOn: "isZoomable",
          value: true,
        },
      }
    case "zoomAnimation":
      return {
        label: trad.ZOOM_ANIMATION,
        propsName: "zoomAnimation",
        type: configurationType.TOGGLE,
        defaultValue: false,
        isConditionnal: {
          dependsOn: "isZoomable",
          value: true,
        },
      }
    case "mapVue":
      return {
        label: trad.MAP_VUE,
        propsName: "mapVue",
        type: configurationType.SELECT,
        defaultValue: "bckgrColor",
        options: [
          {
            value: "bckgrColor",
            name: trad.TYPE_MAP_COLOR,
          },
          {
            value: "bullet",
            name: trad.TYPE_MAP_BULLET,
          },
          {
            value: "bulletBckgrd",
            name: trad.TYPE_MAP_BULLET_COLOR,
          },
          {
            value: "bulletNumber",
            name: trad.TYPE_MAP_BULLET_COLOR_NUMBER,
          },
        ],
      }
    case "mapVisibilityLegend":
      return {
        label: trad.SHOW_LEGEND,
        propsName: "visibilityLegend",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "mapChoice":
      return {
        label: trad.MAP_CHOICE,
        propsName: "mapChoice",
        type: configurationType.SELECT,
        defaultValue: "franceDep",
        options: [
          {
            value: "franceDep",
            name: trad.MAP_FRANCE_DEP,
          },
          {
            value: "franceRegNew",
            name: trad.MAP_FRANCE_REG,
          },
          { value: "europe", name: "Europe" },
          { value: "asiePacifique", name: "Asie pacifique" },
        ],
      }
    case "mapBulletColor":
      return {
        label: trad.BULLET_COLOR,
        propsName: "bulletColor",
        colorPropsName: "bulletColor",
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        activationPropsName: "activeBackground",
        withActivation: false,
        defaultValue: "#4d5860",
        activationDefaultProps: true,
        firstSelectPropsName: "bulletBorderSize",
        firstSelectLabel: "Epaisseur :",
        firstSelect: true,
        secondSelect: false,
        firstSelectOptions: [
          {
            value: "0px",
            name: "0px",
          },
          {
            value: "1px",
            name: "1px",
          },
          {
            value: "2px",
            name: "2px",
          },
          {
            value: "3px",
            name: "3px",
          },
          {
            value: "4px",
            name: "4px",
          },
          {
            value: "5px",
            name: "5px",
          },
        ],
        firstDefaultProps: [
          {
            value: "1px",
            name: "1px",
          },
        ],
        isConditionnal: {
          dependsOn: "mapVue",
          value: ["bullet", "bulletBckgrd", "bulletNumber"],
        },
      }
    case "mapTooltipColor":
      return {
        label: trad.MAP_TOOLTIP_COLOR,
        propsName: "tooltipColor",
        colorPropsName: "tooltipColor",
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        activationPropsName: "activeBackground",
        withActivation: false,
        defaultValue: "#4d5860",
        activationDefaultProps: true,
      }
    case "mapIsDraggable":
      return {
        label: trad.MAP_IS_DRAGGABLE,
        propsName: "isDraggable",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "mapIsZoomable":
      return {
        label: trad.MAP_IS_ZOOMABLE,
        propsName: "isZoomable",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "mapLegendLabel":
      return {
        label: trad.LEGEND_LABEL,
        propsName: "legendLabel",
        type: configurationType.INPUT,
        dataType: "text",
        showIcon: false,
        isConditionnal: {
          dependsOn: "visibilityLegend",
          value: true,
        },
      }
    case "mapLegendLabelStyle":
      return {
        label: trad.LEGEND_LABEL,
        propsName: "legendLabelStyle",
        colorPropsName: "legendLabelColor",
        firstSelectPropsName: "legendLabelSize",
        secondSelectPropsName: "legendLabelWeight",
        firstSelectLabel: "Taille :",
        secondSelectLabel: "Style :",
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        isConditionnal: {
          dependsOn: "visibilityLegend",
          value: true,
        },
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
      }
    case "rotationLabelAxesX":
      return {
        label: trad.LABELS_ROTATION_ON_X_AXE,
        propsName: "rotationLabelAxesX",
        type: configurationType.INPUT,
        dataType: "number",
        defaultValue: -45,
        min: -360,
        max: 360,
      }
    case "mapSwapVue":
      return {
        label: trad.SWAP_MAP,
        propsName: "withChoicePath",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "basicTextTextArea":
      return {
        label: trad.TEXT,
        propsName: "textAreaValue",
        type: configurationType.EDITOR_JODIT,
        defaultValue: "",
      }
    case "basicTextTextAlignement":
      return {
        label: trad.TEXT_ALIGNMENT,
        propsName: "basicTextTextAlignement",
        type: configurationType.ICON_SELECT,
        defaultValue: false,
        withIcon: true,
        activationDefaultProps: true,
        icon: "alignementIcon",
        options: [
          {
            value: "left",
            name: "gauche",
          },
          {
            value: "center",
            name: "centre",
          },
          {
            value: "right",
            name: "droite",
          },
        ],
        defaultValue: [
          {
            value: "left",
            name: "gauche",
          },
        ],
      }
    case "basicTextTextConfig":
      return {
        label: trad.TEXT_STYLE,
        propsName: "basicTextTextStyle",
        colorPropsName: "basicTextTextColor",
        firstSelectPropsName: "basicTextTextSize",
        secondSelectPropsName: "basicTextTextWeight",
        firstSelectLabel: "Taille :",
        secondSelectLabel: "Style :",
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
      }
    case "redirectButtonlabel":
      return {
        label: trad.LABEL,
        propsName: "redirectButtonlabel",
        type: configurationType.INPUT,
        dataType: "text",
        showIcon: false,
      }
    case "redirectButtonBackground":
      return {
        label: trad.COLOR,
        propsName: "redirectButtonBackgroundColor",
        colorPropsName: "redirectButtonBackgroundColor",
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        defaultValue: "#FFFFFF",
        activationDefaultProps: true,
        useColorOpacity: true,
      }
    case "redirectButtonSelectIcon":
      return {
        label: trad.REDIRECT_BUTTON_SELECT_ICON,
        propsName: "redirectButtonSelectIcon",
        type: configurationType.SELECT_ICON,
        defaultValue: "",
        iconList: iconsFontAwesome,
      }
    case "markersGoogleMapSelectIcons":
      return {
        label: trad.REDIRECT_BUTTON_SELECT_ICON,
        propsName: "googleMapIcon",
        type: configurationType.GOOGLE_MAP_ICONS,
        defaultValue: "",
      }
    case "redirectButtonUrl":
      return {
        label: trad.REDIRECT_BUTTON_INPUT_URL,
        propsName: "redirectButtonUrl",
        type: configurationType.INPUT,
        dataType: "text",
        showIcon: false,
        withActivation: true,
        activationPropsName: "redirectButtonIsUrl",
        activationProps: false,
        activationDefaultProps: false,
        listOfInputToDisable: ["redirectButtonIsPageUrl", "redirectButtonIsReferentiel"],
      }
    case "redirectButtonUrlPage":
      return {
        label: trad.REDIRECT_BUTTON_SELECT_URL,
        propsName: "redirectButtonPageUrl",
        showIcon: false,
        type: configurationType.PAGE_SELECT,
        withActivation: true,
        activationPropsName: "redirectButtonIsPageUrl",
        activationDefaultProps: false,
        listOfInputToDisable: ["redirectButtonIsUrl", "redirectButtonIsReferentiel"],
      }
    case "redirectButtonReferentiel":
      return {
        label: trad.REDIRECT_BUTTON_SELECT_REFERENTIEL,
        propsName: "redirectButtonReferentiel",
        showIcon: false,
        type: configurationType.PAGE_REFERENTIEL,
        withActivation: true,
        activationPropsName: "redirectButtonIsReferentiel",
        activationDefaultProps: false,
        listOfInputToDisable: ["redirectButtonIsPageUrl", "redirectButtonIsUrl"],
      }
    case "redirectButtonIconAlignement":
      return {
        label: trad.ICON_ALIGNMENT,
        propsName: "redirectButtonIconAlignement",
        type: configurationType.ICON_SELECT,
        defaultValue: false,
        withIcon: true,
        activationDefaultProps: true,
        icon: "alignementIcon",
        options: [
          {
            value: "left",
            name: trad.LEFT,
          },
          {
            value: "right",
            name: trad.RIGHT,
          },
        ],
        defaultValue: [
          {
            value: "right",
            name: trad.RIGHT,
          },
        ],
      }
    case "redirectButtonBorderStyle":
      return {
        label: trad.BORDER,
        propsName: "redirectButtonBorderColor",
        colorPropsName: "redirectButtonBorderColor",
        firstSelectPropsName: "redirectButtonBorderSize",
        secondSelectPropsName: "redirectButtonBorderStyle",
        firstSelectLabel: trad.THICKNESS + " :",
        secondSelectLabel: trad.STYLE + " :",
        withActivation: true,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        activationPropsName: "redirectButtonBorderActive",
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: false,
        useColorOpacity: true,
        firstSelectOptions: [
          {
            value: "1px",
            name: "1px",
          },
          {
            value: "2px",
            name: "2px",
          },
          {
            value: "3px",
            name: "3px",
          },
          {
            value: "4px",
            name: "4px",
          },
          {
            value: "5px",
            name: "5px",
          },
        ],
        secondSelectOptions: [
          {
            value: "solid",
            name: "solid",
          },
          {
            value: "dotted",
            name: "dotted",
          },
          {
            value: "dashed",
            name: "dashed",
          },
          {
            value: "groove",
            name: "groove",
          },
          {
            value: "ridge",
            name: "ridge",
          },
          {
            value: "inset",
            name: "inset",
          },
          {
            value: "outset",
            name: "outset",
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1px",
            name: "1px",
          },
        ],
        secondDefaultProps: [
          {
            value: "solid",
            name: "solid",
          },
        ],
      }
    case "progressBarHeight":
      return {
        label: trad.PROGRESS_BAR_HEIGHT,
        propsName: "progressBarHeight",
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: false,
        showIcon: false,
        defaultValue: 15,
        min: 10,
        max: 40,
      }
    case "progressBarRadius":
      return {
        label: trad.ANGLES,
        propsName: "progressBarRadius",
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: false,
        showIcon: false,
        defaultValue: 20,
        min: 0,
        max: 40,
      }
    case "imageInput":
      return {
        label: trad.UPLOAD_A_NEW_PHOTO,
        propsName: "tempUrlImage",
        type: configurationType.PHOTO_INPUT,
        additionnalText: trad.UPLOAD_TEXT_BTN,
      }
    case "opacity":
      return {
        label: trad.OPACITY,
        propsName: "opacity",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "opacityPercent":
      return {
        label: trad.TRANSPARENCY,
        propsName: "opacityPercent",
        isConditionnal: {
          dependsOn: "opacity",
          value: true,
        },
        type: configurationType.INPUT,
        dataType: "number",
        defaultValue: 100,
        min: 0,
        max: 100,
      }
    case "blur":
      return {
        label: trad.BLUR,
        propsName: "blur",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    // Description en info-bulle à côté du titre (texte brut, cf. `Containers/Widget/WidgetDescription`).
    case "widgetDescription":
      return {
        label: trad.WIDGET_DESCRIPTION || "Description (tooltip)",
        propsName: "description",
        type: configurationType.TEXT_AREA,
        defaultValue: "",
      }
    case "titleActivation":
      return {
        label: trad.DO_NOT_DISPLAY_WIDGET_TITLE,
        propsName: "disableTitle",
        type: configurationType.TOGGLE,
        defaultValue: true,
      }
    case "hideLabels":
      return {
        label: trad.HIDE_LABELS,
        propsName: "disableLabel",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    // Total de la pile : n'a de sens que sur un histogramme empile. La condition porte sur
    // `typeBarChart`, qui n'est renseigne qu'apres passage du sous-type en "empile" — le
    // reglage reste donc invisible sur un histogramme simple.
    case "showStackTotal":
      return {
        label: trad.SHOW_STACK_TOTAL,
        propsName: "showStackTotal",
        isConditionnal: {
          dependsOn: "typeBarChart",
          value: "stackedBar",
        },
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "stackTotalColor":
      return {
        label: trad.STACK_TOTAL_COLOR,
        propsName: "stackTotalColor",
        isConditionnal: [
          { dependsOn: "typeBarChart", value: "stackedBar" },
          { dependsOn: "showStackTotal", value: true },
        ],
        type: configurationType.COLOR_SELECTOR,
        defaultValue: colors.textPrimary,
      }
    case "stackTotalFontSize":
      return {
        label: trad.STACK_TOTAL_FONT_SIZE,
        propsName: "stackTotalFontSize",
        isConditionnal: [
          { dependsOn: "typeBarChart", value: "stackedBar" },
          { dependsOn: "showStackTotal", value: true },
        ],
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: true,
        defaultValue: 13,
        showIcon: false,
        min: 8,
        max: 40,
      }
    case "typeLabelText":
      return {
        label: trad.TYPE_LABEL_TEXT,
        propsName: "typeLabelText",
        isConditionnal: {
          dependsOn: "hideExternalSerieLabel",
          value: false,
        },
        type: configurationType.SELECT,
        defaultValue: "percent",
        options: [
          {
            value: "percent",
            name: trad.PERCENT,
          },
          {
            value: "value",
            name: trad.VALUE,
          },
        ],
      }
    case "isGradientRange":
      return {
        label: trad.PERSONALIZED_RANGE,
        propsName: "isGradientRange",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "ranges":
      return {
        label: trad.CONFIGURATION_RANGES,
        propsName: "ranges",
        isConditionnal: {
          dependsOn: "isGradientRange",
          value: true,
        },
        type: configurationType.RANGES,
      }
    case "axisForceMinMax":
      return {
        label: trad.CUSTOM_SCALE,
        propsName: "valueForceMinMax",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "axisMax":
      return {
        label: trad.AXIS_END,
        propsName: "valueAxisMax",
        isConditionnal: {
          dependsOn: "valueForceMinMax",
          value: true,
        },
        type: configurationType.INPUT,
        dataType: "number",
        showIcon: false,
        axisMax: 0,
      }
    case "axisMin":
      return {
        label: trad.AXIS_START,
        propsName: "valueAxisMin",
        isConditionnal: {
          dependsOn: "valueForceMinMax",
          value: true,
        },
        type: configurationType.INPUT,
        dataType: "number",
        showIcon: false,
        defaultValue: 0,
      }
    case "axisStartZero":
      return {
        label: trad.START_AXIS_TO_ZERO,
        propsName: "axisStartZero",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "integerValueAxis":
      return {
        label: trad.INTEGER_VALUE_AXIS,
        propsName: "integerValueAxis",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "hideCenteredValue":
      return {
        label: trad.HIDE_CENTERED_VALUE,
        propsName: "hideTitleInCenter",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "titleCenterStyle":
      return {
        label: trad.STYLE_CENTERED_VALUE,
        propsName: "titleCenterStyle",
        isConditionnal: {
          dependsOn: "hideTitleInCenter",
          value: false,
        },
        colorPropsName: "colorTitleCenter",
        firstSelectPropsName: "fontSizeTitleCenter",
        secondSelectPropsName: "fontWeightTitleCenter",
        firstSelectLabel: `${trad.SIZE} :`,
        secondSelectLabel: `${trad.STYLE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
      }
    case "typeOfExternalLabel":
      return {
        label: trad.TYPE_EXTERNAL_LABEL_TEXT,
        propsName: "typeOfExternalLabel",
        isConditionnal: {
          dependsOn: "hideExternalSerieLabel",
          value: false,
        },
        type: configurationType.SELECT,
        defaultValue: "value",
        options: [
          {
            value: "text",
            name: trad.TEXT,
          },
          {
            value: "value",
            name: trad.VALUE,
          },
          {
            value: "text_and_value",
            name: trad.TEXT_AND_VALUE,
          },
          {
            value: "value_and_text",
            name: trad.VALUE_AND_TEXT,
          },
        ],
      }
    case "bodyOddRowBackgroundColor":
      return {
        label: trad.COLOR_ODD_LINE,
        propsName: "bodyOddRowBackgroundColor",
        type: configurationType.COLOR_SELECTOR,
        defaultValue: "#FFFFFF",
      }
    case "bodyEvenRowBackgroundColor":
      return {
        label: trad.COLOR_EVEN_LINE,
        propsName: "bodyEvenRowBackgroundColor",
        type: configurationType.COLOR_SELECTOR,
        defaultValue: "#F4F4F4",
      }
    case "dropdownBordureStyle":
      return {
        label: trad.BORDER,
        propsName: "dropdownBordureStyle",
        colorPropsName: "dropdownBorderColor",
        firstSelectPropsName: "dropdownBorderSize",
        secondSelectPropsName: "dropdownBorderStyle",
        firstSelectLabel: trad.THICKNESS + " :",
        secondSelectLabel: trad.STYLE + " :",
        withActivation: true,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        activationPropsName: "activeBorder",
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: false,
        useColorOpacity: true,
        firstSelectOptions: [
          {
            value: "1px",
            name: "1px",
          },
          {
            value: "2px",
            name: "2px",
          },
          {
            value: "3px",
            name: "3px",
          },
          {
            value: "4px",
            name: "4px",
          },
          {
            value: "5px",
            name: "5px",
          },
        ],
        secondSelectOptions: [
          {
            value: "solid",
            name: "solid",
          },
          {
            value: "dotted",
            name: "dotted",
          },
          {
            value: "dashed",
            name: "dashed",
          },
          {
            value: "groove",
            name: "groove",
          },
          {
            value: "ridge",
            name: "ridge",
          },
          {
            value: "inset",
            name: "inset",
          },
          {
            value: "outset",
            name: "outset",
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1px",
            name: "1px",
          },
        ],
        secondDefaultProps: [
          {
            value: "solid",
            name: "solid",
          },
        ],
      }
    case "dropdownBorderRadius":
      var options = []
      for (let i = 0; i <= 20; i++) {
        options.push({
          value: `${i}px`,
          name: `${i}px`,
        })
      }
      return {
        label: trad.ANGLES,
        propsName: "dropdownBorderRadius",
        type: configurationType.ICON_SELECT,
        activationPropsName: "activeRadius",
        withActivation: true,
        defaultValue: false,
        withIcon: true,
        icon: "borderRadiusIcon",
        activationDefaultProps: false,
        defaultValue: [
          {
            value: "10px",
            name: "10px",
          },
        ],
        options: options,
      }
    case "calendarBordureStyle":
      return {
        label: trad.BORDER,
        propsName: "calendarBordureStyle",
        colorPropsName: "calendarBorderColor",
        firstSelectPropsName: "calendarBorderSize",
        secondSelectPropsName: "calendarBorderStyle",
        firstSelectLabel: trad.THICKNESS + " :",
        secondSelectLabel: trad.STYLE + " :",
        withActivation: true,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        activationPropsName: "activeBorder",
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: false,
        useColorOpacity: true,
        firstSelectOptions: [
          {
            value: "1px",
            name: "1px",
          },
          {
            value: "2px",
            name: "2px",
          },
          {
            value: "3px",
            name: "3px",
          },
          {
            value: "4px",
            name: "4px",
          },
          {
            value: "5px",
            name: "5px",
          },
        ],
        secondSelectOptions: [
          {
            value: "solid",
            name: "solid",
          },
          {
            value: "dotted",
            name: "dotted",
          },
          {
            value: "dashed",
            name: "dashed",
          },
          {
            value: "groove",
            name: "groove",
          },
          {
            value: "ridge",
            name: "ridge",
          },
          {
            value: "inset",
            name: "inset",
          },
          {
            value: "outset",
            name: "outset",
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1px",
            name: "1px",
          },
        ],
        secondDefaultProps: [
          {
            value: "solid",
            name: "solid",
          },
        ],
      }
    case "calendarBorderRadius":
      var options = []
      for (let i = 0; i <= 20; i++) {
        options.push({
          value: `${i}px`,
          name: `${i}px`,
        })
      }
      return {
        label: trad.ANGLES,
        propsName: "calendarBorderRadius",
        type: configurationType.ICON_SELECT,
        activationPropsName: "activeRadius",
        withActivation: true,
        defaultValue: false,
        withIcon: true,
        icon: "borderRadiusIcon",
        activationDefaultProps: false,
        defaultValue: [
          {
            value: "10px",
            name: "10px",
          },
        ],
        options: options,
      }
    case "displayTypeLabel":
      return {
        label: trad.TYPE_LABEL_TEXT,
        propsName: "displayTypeLabel",
        type: configurationType.SELECT,
        defaultValue: "default",
        options: [
          {
            value: "default",
            name: trad.DEFAULT,
          },
          {
            value: "truncate",
            name: trad.TRUNCATE,
          },
          {
            value: "wrap",
            name: trad.WRAP,
          },
        ],
      }
    case "enableCountRow":
      return {
        label: trad.DISPLAY_NUMBER_OF_LINE,
        propsName: "enableCountRow",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "showCenteredValue":
      return {
        label: trad.SHOW_CENTERED_VALUE,
        propsName: "showCenteredValue",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "customCenteredValue":
      return {
        label: trad.CUSTOM_CENTER_TEXT,
        propsName: "customCenteredValue",
        type: configurationType.INPUT,
        isConditionnal: {
          dependsOn: "showCenteredValue",
          value: true,
        },
        dataType: "text",
        showIcon: false,
      }
    case "showLabel":
      return {
        label: trad.SHOW_LABEL,
        propsName: "showLabel",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "labelPosition":
      return {
        label: trad.LABEL_POSITION,
        propsName: "labelPosition",
        type: configurationType.ICON_SELECT,
        defaultValue: false,
        withIcon: true,
        activationDefaultProps: true,
        icon: "alignementIcon",
        options: [
          {
            value: "top",
            name: trad.TOP,
          },
          {
            value: "center",
            name: trad.CENTERED,
          },
          {
            value: "bottom",
            name: trad.BOTTOM,
          },
        ],
        defaultValue: [
          {
            value: "bottom",
            name: trad.BOTTOM,
          },
        ],
        isConditionnal: {
          dependsOn: "disableLabel",
          value: true,
        },
      }
    case "labelStyleConditional":
      return {
        label: trad.LABEL,
        firstSelectPropsName: "labelSize",
        secondSelectPropsName: "labelWeight",
        firstSelectLabel: "Taille :",
        secondSelectLabel: "Style :",
        type: configurationType.FULL_TEXT_PARAM,
        firstSelect: true,
        secondSelect: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
        isConditionnal: {
          dependsOn: "disableLabel",
          value: true,
        },
      }
    case "hideCenteredText":
      return {
        label: trad.HIDE_CENTERED_TEXT,
        propsName: "hideCenteredText",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "hideExternalSerieLabel":
      return {
        label: trad.HIDE_EXTERNAL_LABEL,
        propsName: "hideExternalSerieLabel",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "externalSerieLabelStyle":
      return {
        label: trad.STYLE_LABELS,
        propsName: "externalLabelColor",
        colorPropsName: "externalLabelColor",
        firstSelectPropsName: "externalLabelSize",
        secondSelectPropsName: "externalLabelWeight",
        firstSelectLabel: "Taille :",
        secondSelectLabel: "Style :",
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeNumberOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: 1,
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
        isConditionnal: {
          dependsOn: "hideExternalSerieLabel",
          value: false,
        },
      }
    case "externalSerieValueStyle":
      return {
        label: trad.STYLE_VALUES,
        propsName: "externalValueColor",
        colorPropsName: "externalValueColor",
        firstSelectPropsName: "externalValueSize",
        secondSelectPropsName: "externalValueWeight",
        firstSelectLabel: "Taille :",
        secondSelectLabel: "Style :",
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeNumberOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: 1,
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
        isConditionnal: {
          dependsOn: "hideExternalSerieLabel",
          value: false,
        },
      }
    case "hideValues":
      return {
        label: trad.HIDE_VALUES,
        propsName: "hideValues",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "progressBarValueStyleConditional":
      return {
        label: trad.STYLE_VALUES,
        firstSelectPropsName: "valueSize",
        secondSelectPropsName: "valueWeight",
        firstSelectLabel: "Taille :",
        secondSelectLabel: "Style :",
        type: configurationType.FULL_TEXT_PARAM,
        firstSelect: true,
        secondSelect: true,
        firstSelectOptions: fontSizeNumberOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        firstDefaultProps: [
          {
            value: 1,
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "bold",
            name: "bold",
          },
        ],
        isConditionnal: {
          dependsOn: "hideValues",
          value: false,
        },
      }
    case "displayInMultipleProgressBar":
      return {
        label: trad.DISPLAY_IN_MULTIPLE_PROGRESS_BAR,
        propsName: "displayInMultipleProgressBar",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "progressBarNumber":
      return {
        label: trad.PROGRESS_BAR_NUMBER,
        propsName: "progressBarNumber",
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: false,
        showIcon: false,
        defaultValue: 10,
        min: 1,
        max: 40,
        isConditionnal: {
          dependsOn: "displayInMultipleProgressBar",
          value: true,
        },
      }
    case "centeredText":
      return {
        label: trad.CENTRAL_TEXT,
        propsName: "label",
        type: configurationType.INPUT,
        defaultValue: trad.CENTRAL_TEXT,
        dataType: "text",
        showIcon: false,
        isConditionnal: {
          dependsOn: "hideCenteredText",
          value: false,
        },
      }
    case "centeredTextStyle":
      return {
        label: trad.STYLE_CENTERED_TEXT,
        propsName: "labelColor",
        colorPropsName: "labelColor",
        firstSelectPropsName: "labelSize",
        secondSelectPropsName: "labelWeight",
        firstSelectLabel: "Taille :",
        secondSelectLabel: "Style :",
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
        isConditionnal: {
          dependsOn: "hideCenteredText",
          value: false,
        },
      }
    case "borderActivation":
      return {
        label: trad.ACTIVE_BORDER,
        propsName: "borderActivation",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "uniqueColor":
      return {
        label: trad.SINGLE_COLOR,
        propsName: "uniqueColor",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "uniqueColorValue":
      return {
        label: trad.SINGLE_COLOR_VALUE,
        propsName: "uniqueColorValue",
        type: configurationType.COLOR_SELECTOR,
        defaultValue: "#000000",
        isConditionnal: {
          dependsOn: "uniqueColor",
          value: true,
        },
      }
    case "tooltipActivation":
      return {
        label: trad.TOOLTIP_ACTIVATION,
        propsName: "tooltipActivation",
        type: configurationType.TOGGLE,
        defaultValue: true,
      }
    case "tooltipValueType":
      return {
        label: trad.TYPE_LABEL_TEXT,
        propsName: "tooltipValueType",
        isConditionnal: {
          dependsOn: "tooltipActivation",
          value: true,
        },
        type: configurationType.SELECT,
        defaultValue: "text_and_value",
        options: [
          {
            value: "text",
            name: trad.TEXT,
          },
          {
            value: "value",
            name: trad.VALUE,
          },
          {
            value: "text_and_value",
            name: trad.TEXT_AND_VALUE,
          },
        ],
      }
    case "typeValue":
      return {
        label: trad.TYPE_LABEL_VALUE,
        propsName: "typeValue",
        isConditionnal: {
          dependsOn: "hideValues",
          value: false,
        },
        type: configurationType.SELECT,
        defaultValue: "percent",
        options: [
          {
            value: "percent",
            name: trad.PERCENT,
          },
          {
            value: "value",
            name: trad.VALUE,
          },
          {
            value: "value_and_percent",
            name: trad.VALUE_AND_PERCENT,
          },
          {
            value: "percent_and_value",
            name: trad.PERCENT_AND_VALUE,
          },
        ],
      }
    case "hideAxeXLabel":
      return {
        label: trad.HIDE_AXE_X_LABEL,
        propsName: "hideAxeXLabel",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "hideAxeYLabel":
      return {
        label: trad.HIDE_AXE_Y_LABEL,
        propsName: "hideAxeYLabel",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "enableZoom":
      return {
        label: trad.ENABLE_TREE_ZOOM,
        propsName: "enableZoom",
        type: configurationType.TOGGLE,
        defaultValue: true,
      }
    case "enableNavigationBar":
      return {
        label: trad.ENABLE_NAVIGATION_BAR,
        propsName: "enableNavigationBar",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "maxLevelInSameTime":
      return {
        label: trad.MAX_LEVELS_AT_ONCE,
        propsName: "maxLevelInSameTime",
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: false,
        showIcon: false,
        defaultValue: 1,
        min: 1,
        max: 3,
      }
    case "initialViewText":
      return {
        label: trad.INITIAL_VIEW_TEXT,
        propsName: "initialViewText",
        type: configurationType.INPUT,
        dataType: "text",
        showIcon: false,
        isConditionnal: {
          dependsOn: "enableNavigationBar",
          value: true,
        },
      }
    case "bulletLabelType":
      return {
        label: trad.TYPE_CENTRAL_TEXT,
        propsName: "bulletLabelType",
        type: configurationType.SELECT,
        defaultValue: "default",
        options: [
          {
            value: "default",
            name: trad.DEFAULT,
          },
          {
            value: "value",
            name: trad.VALUE,
          },
          {
            value: "name_and_value",
            name: trad.NAME_AND_VALUE,
          },
        ],
      }
    case "bulletLabelStyle":
      return {
        label: trad.CENTRAL_LABEL_STYLE,
        propsName: "bulletLabelStyle",
        colorPropsName: "bulletLabelColor",
        firstSelectPropsName: "bulletLabelFontSize",
        secondSelectPropsName: "bulletLabelWeight",
        firstSelectLabel: `${trad.SIZE} :`,
        secondSelectLabel: `${trad.STYLE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        activationDefaultProps: true,
        firstSelect: true,
        secondSelect: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: "bold",
          },
          {
            value: "normal",
            name: "normal",
          },
        ],
        defaultValue: "#FFFFFF",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
        isConditionnal: {
          dependsOn: "bulletLabelType",
          value: ["default", "name_and_value"],
        },
      }
    case "bulletValueStyle":
      return {
        label: trad.CENTRAL_VALUE_STYLE,
        propsName: "bulletValueStyle",
        colorPropsName: "bulletValueColor",
        firstSelectPropsName: "bulletValueFontSize",
        secondSelectPropsName: "bulletValueWeight",
        firstSelectLabel: `${trad.SIZE} :`,
        secondSelectLabel: `${trad.STYLE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        activationDefaultProps: true,
        firstSelect: true,
        secondSelect: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: "bold",
          },
          {
            value: "normal",
            name: "normal",
          },
        ],
        defaultValue: "#FFFFFF",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
        isConditionnal: {
          dependsOn: "bulletLabelType",
          value: ["value", "name_and_value"],
        },
      }
    case "iconSelected":
      return {
        label: trad.REDIRECT_BUTTON_SELECT_ICON,
        propsName: "iconSelected",
        type: configurationType.SELECT_ICON,
        defaultValue: "",
        iconList: iconsFontAwesome,
      }
    case "iconPosition":
      return {
        label: trad.ICON_ALIGNMENT,
        propsName: "iconPosition",
        type: configurationType.ICON_SELECT,
        defaultValue: false,
        withIcon: true,
        activationDefaultProps: true,
        icon: "alignementIcon",
        options: [
          {
            value: "left",
            name: trad.LEFT,
          },
          {
            value: "right",
            name: trad.RIGHT,
          },
        ],
        defaultValue: [
          {
            value: "left",
            name: trad.LEFT,
          },
        ],
        isConditionnal: {
          dependsOn: "iconSelected",
          value: iconsFontAwesome,
        },
      }
    case "iconOpacity":
      return {
        label: trad.ICON_OPACITY,
        propsName: "iconOpacity",
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: true,
        showIcon: false,
        defaultValue: 100,
        min: 5,
        max: 100,
        step: 1,
        isConditionnal: {
          dependsOn: "iconSelected",
          value: iconsFontAwesome,
        },
      }
    case "iconStyle":
      return {
        label: trad.ICON_STYLE,
        propsName: "iconStyle",
        colorPropsName: "iconColor",
        firstSelectPropsName: "iconFontSize",
        firstSelectLabel: `${trad.SIZE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: [
          ...fontSizeOptions,
          {
            value: "4.2rem",
            name: "42",
          },
          {
            value: "4.8rem",
            name: "48",
          },
          {
            value: "5.4rem",
            name: "54",
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        isConditionnal: {
          dependsOn: "iconSelected",
          value: iconsFontAwesome,
        },
      }
    case "freezeFirstColumn":
      return {
        label: trad.FREEZE_FIRST_COLUMN,
        propsName: "freezeFirstColumn",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "resizableColumns":
      return {
        label: trad.RESIZABLE_COLUMNS,
        propsName: "resizableColumns",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "enableTooltipCell":
      return {
        label: trad.ENABLE_TOOLTIP_CELL,
        propsName: "enableTooltipCell",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "columnCornerRadius":
      return {
        label: trad.GAUGE_ROUNDING,
        propsName: "columnCornerRadius",
        type: configurationType.INPUT,
        dataType: "number",
        defaultValue: 10,
      }
    case "typeOfMaxValue":
      return {
        label: trad.TYPE_MAX_VALUE,
        propsName: "typeOfMaxValue",
        type: configurationType.SELECT,
        defaultValue: "total",
        options: [
          {
            value: "total",
            name: trad.SUM_OF_ALL,
          },
          {
            value: "max",
            name: trad.MAX_VALUE,
          },
        ],
      }
    case "anglePresets":
      return {
        label: trad.ANGLE_PRESETS,
        propsName: "endAngle",
        type: configurationType.SELECT,
        defaultValue: 275,
        options: [
          {
            value: 0.1,
            name: trad.LINEAR_GAUGE,
          },
          {
            value: 270,
            name: trad.CIRCULAR_GAUGE_75,
          },
          {
            value: 360,
            name: trad.CIRCULAR_GAUGE_100,
          },
        ],
      }
    case "hideCentralValue":
      return {
        label: trad.HIDE_CENTERED_VALUE,
        propsName: "hideCentralValue",
        type: configurationType.TOGGLE,
        defaultValue: false,
        // isConditionnal: {
        //   dependsOn: "endAngle",
        //   value:
        // }
      }
    case "hideAxisValues":
      return {
        label: trad.HIDE_AXIS_VALUES,
        propsName: "hideAxisValues",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "valueTitleCenterStyle":
      return {
        label: trad.STYLE_CENTERED_VALUE,
        propsName: "valueTitleCenterStyle",
        colorPropsName: "colorValueTitleCenter",
        firstSelectPropsName: "fontSizeValueTitleCenter",
        secondSelectPropsName: "fontWeightValueTitleCenter",
        firstSelectLabel: `${trad.SIZE} :`,
        secondSelectLabel: `${trad.STYLE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: "bold",
          },
          {
            value: "normal",
            name: "normal",
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
        isConditionnal: [
          {
            dependsOn: "hideCentralValue",
            value: false,
          },
          {
            dependsOn: "typeOfCentralValue",
            value: ["value", "value_and_percent", "value_percent_custom"],
          },
        ],
      }
    case "subTitleCenterStyle":
      return {
        label: trad.STYLE_CENTERED_PERCENT,
        propsName: "subTitleCenterStyle",
        colorPropsName: "colorSubTitleCenter",
        firstSelectPropsName: "fontSizeSubTitleCenter",
        secondSelectPropsName: "fontWeightSubTitleCenter",
        firstSelectLabel: `${trad.SIZE} :`,
        secondSelectLabel: `${trad.STYLE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: "bold",
          },
          {
            value: "normal",
            name: "normal",
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
        isConditionnal: [
          {
            dependsOn: "hideCentralValue",
            value: false,
          },
          {
            dependsOn: "typeOfCentralValue",
            value: ["value_and_percent", "value_percent_custom"],
          },
        ],
      }
    case "customLabelCenterStyle":
      return {
        label: trad.CENTRAL_LABEL_STYLE,
        propsName: "customLabelCenterStyle",
        colorPropsName: "colorCustomLabelCenter",
        firstSelectPropsName: "fontSizeCustomLabelCenter",
        secondSelectPropsName: "fontWeightCustomLabelCenter",
        firstSelectLabel: `${trad.SIZE} :`,
        secondSelectLabel: `${trad.STYLE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: "bold",
          },
          {
            value: "normal",
            name: "normal",
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
        isConditionnal: [
          {
            dependsOn: "hideCentralValue",
            value: false,
          },
          {
            dependsOn: "typeOfCentralValue",
            value: ["custom", "value_percent_custom"],
          },
        ],
      }
    case "typeOfCentralValue":
      return {
        label: trad.TYPE_CENTRAL_TEXT,
        propsName: "typeOfCentralValue",
        type: configurationType.SELECT,
        defaultValue: "value",
        options: [
          {
            value: "value",
            name: trad.VALUE,
          },
          {
            value: "value_and_percent",
            name: trad.VALUE_AND_PERCENT,
          },
          {
            value: "custom",
            name: trad.CUSTOM_TEXT,
          },
          {
            value: "value_percent_custom",
            name: trad.VALUE_PERCENT_AND_CUSTOM,
          },
        ],
        isConditionnal: {
          dependsOn: "hideCentralValue",
          value: false,
        },
      }
    case "customLabelInput":
      return {
        label: trad.CUSTOM_CENTER_TEXT,
        propsName: "customLabelInput",
        type: configurationType.INPUT,
        defaultValue: "",
        showIcon: false,
        isConditionnal: [
          {
            dependsOn: "hideCentralValue",
            value: false,
          },
          {
            dependsOn: "typeOfCentralValue",
            value: ["custom", "value_percent_custom"],
          },
        ],
      }
    case "innerGaugeRadius":
      return {
        label: trad.INNER_RADIUS,
        propsName: "innerRadius",
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: false,
        defaultValue: 50,
        min: 0,
        max: 100,
        isConditionnal: {
          dependsOn: "endAngle",
          value: ["270", "360"],
        },
      }
    case "iconPositiveSelected":
      return {
        label: trad.ICON_POSITIVE_SELECTED,
        propsName: "iconPositiveSelected",
        type: configurationType.SELECT_ICON,
        defaultValue: "fas fa-arrow-up",
        iconList: iconsFontAwesome,
        isConditionnal: {
          dependsOn: "evolutionThemeStyle",
          value: "customStyle",
        },
      }
    case "iconPositiveStyle":
      return {
        label: trad.ICON_POSITIVE_STYLE,
        propsName: "iconPositiveStyle",
        colorPropsName: "iconPositiveColor",
        firstSelectPropsName: "iconPositiveFontSize",
        firstSelectLabel: `${trad.SIZE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: [
          ...fontSizeOptions,
          {
            value: "4.2rem",
            name: "42",
          },
          {
            value: "4.8rem",
            name: "48",
          },
          {
            value: "5.4rem",
            name: "54",
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        isConditionnal: [
          {
            dependsOn: "iconPositiveSelected",
            value: iconsFontAwesome,
          },
          {
            dependsOn: "evolutionThemeStyle",
            value: "customStyle",
          },
        ],
      }
    case "iconNegativeSelected":
      return {
        label: trad.ICON_NEGATIVE_SELECTED,
        propsName: "iconNegativeSelected",
        type: configurationType.SELECT_ICON,
        defaultValue: "fas fa-arrow-down",
        iconList: iconsFontAwesome,
        isConditionnal: {
          dependsOn: "evolutionThemeStyle",
          value: "customStyle",
        },
      }
    case "iconNegativeStyle":
      return {
        label: trad.ICON_NEGATIVE_STYLE,
        propsName: "iconNegativeStyle",
        colorPropsName: "iconNegativeColor",
        firstSelectPropsName: "iconNegativeFontSize",
        firstSelectLabel: `${trad.SIZE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: [
          ...fontSizeOptions,
          {
            value: "4.2rem",
            name: "42",
          },
          {
            value: "4.8rem",
            name: "48",
          },
          {
            value: "5.4rem",
            name: "54",
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        isConditionnal: [
          {
            dependsOn: "iconNegativeSelected",
            value: iconsFontAwesome,
          },
          {
            dependsOn: "evolutionThemeStyle",
            value: "customStyle",
          },
        ],
      }
    case "iconNeutralSelected":
      return {
        label: trad.ICON_NEUTRAL_SELECTED,
        propsName: "iconNeutralSelected",
        type: configurationType.SELECT_ICON,
        defaultValue: "fas fa-arrow-right",
        iconList: iconsFontAwesome,
        isConditionnal: {
          dependsOn: "evolutionThemeStyle",
          value: "customStyle",
        },
      }
    case "iconNeutralStyle":
      return {
        label: trad.ICON_NEUTRAL_STYLE,
        propsName: "iconNeutralStyle",
        colorPropsName: "iconNeutralColor",
        firstSelectPropsName: "iconNeutralFontSize",
        firstSelectLabel: `${trad.SIZE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: [
          ...fontSizeOptions,
          {
            value: "4.2rem",
            name: "42",
          },
          {
            value: "4.8rem",
            name: "48",
          },
          {
            value: "5.4rem",
            name: "54",
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        isConditionnal: [
          {
            dependsOn: "iconNeutralSelected",
            value: iconsFontAwesome,
          },
          {
            dependsOn: "evolutionThemeStyle",
            value: "customStyle",
          },
        ],
      }
    case "valuePositiveStyle":
      return {
        label: trad.VALUE_POSITIVE_STYLE,
        propsName: "valuePositiveStyle",
        colorPropsName: "valuePositiveColor",
        firstSelectPropsName: "valuePositiveSize",
        secondSelectPropsName: "valuePositiveWeight",
        firstSelectLabel: `${trad.SIZE} :`,
        secondSelectLabel: `${trad.STYLE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
        isConditionnal: {
          dependsOn: "evolutionThemeStyle",
          value: "customStyle",
        },
      }
    case "valueNeutralStyle":
      return {
        label: trad.VALUE_NEUTRAL_STYLE,
        propsName: "valueNeutralStyle",
        colorPropsName: "valueNeutralColor",
        firstSelectPropsName: "valueNeutralSize",
        secondSelectPropsName: "valueNeutralWeight",
        firstSelectLabel: `${trad.SIZE} :`,
        secondSelectLabel: `${trad.STYLE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
        isConditionnal: {
          dependsOn: "evolutionThemeStyle",
          value: "customStyle",
        },
      }
    case "valueNegativeStyle":
      return {
        label: trad.VALUE_NEGATIVE_STYLE,
        propsName: "valueNegativeStyle",
        colorPropsName: "valueNegativeColor",
        firstSelectPropsName: "valueNegativeSize",
        secondSelectPropsName: "valueNegativeWeight",
        firstSelectLabel: `${trad.SIZE} :`,
        secondSelectLabel: `${trad.STYLE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
        isConditionnal: {
          dependsOn: "evolutionThemeStyle",
          value: "customStyle",
        },
      }
    case "comparisonStyle":
      return {
        label: trad.COMPARISON_STYLE,
        propsName: "comparisonStyle",
        colorPropsName: "comparisonColor",
        firstSelectPropsName: "comparisonSize",
        secondSelectPropsName: "comparisonWeight",
        firstSelectLabel: `${trad.SIZE} :`,
        secondSelectLabel: `${trad.STYLE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
        isConditionnal: {
          dependsOn: "evolutionThemeStyle",
          value: "customStyle",
        },
      }
    case "percentOrDelta":
      return {
        label: trad.PERCENT_OR_DELTA,
        propsName: "percentOrDelta",
        type: configurationType.SELECT,
        defaultValue: "percent",
        options: [
          {
            value: "percent",
            name: trad.PERCENT,
          },
          {
            value: "delta",
            name: trad.DELTA,
          },
        ],
      }
    case "customLabel":
      return {
        label: trad.CUSTOM_CENTER_TEXT,
        propsName: "customLabel",
        type: configurationType.INPUT,
        defaultValue: "",
        showIcon: false,
      }
    case "customLabelStyle":
      return {
        label: trad.CUSTOM_LABEL_STYLE,
        propsName: "customLabelColor",
        colorPropsName: "customLabelColor",
        firstSelectPropsName: "customLabelSize",
        secondSelectPropsName: "customLabelWeight",
        firstSelectLabel: `${trad.SIZE} :`,
        secondSelectLabel: `${trad.STYLE} :`,
        type: configurationType.FULL_TEXT_COLOR_PARAM,
        withActivation: false,
        firstSelect: true,
        secondSelect: true,
        activationDefaultProps: true,
        firstSelectOptions: fontSizeOptions,
        secondSelectOptions: [
          {
            value: "bold",
            name: trad.BOLD,
          },
          {
            value: "lighter",
            name: trad.LIGHTER,
          },
          {
            value: "normal",
            name: trad.NORMAL,
          },
        ],
        defaultValue: "#000000",
        firstDefaultProps: [
          {
            value: "1rem",
            name: "10",
          },
        ],
        secondDefaultProps: [
          {
            value: "normal",
            name: "normal",
          },
        ],
      }
    case "evolutionThemeStyle":
      return {
        label: trad.STYLE,
        propsName: "evolutionThemeStyle",
        type: configurationType.SELECT,
        defaultValue: "defaultStyle",
        options: [
          {
            value: "customStyle",
            name: trad.CUSTOM_STYLE,
          },
          {
            value: "defaultStyle",
            name: trad.DEFAULT_STYLE,
          },
        ],
      }
    case "colorMinValue":
      return {
        label: trad.MINIMAL_COLOR,
        propsName: "colorMinValue",
        type: configurationType.COLOR_SELECTOR,
        defaultValue: "#fffa76",
      }
    case "colorMaxValue":
      return {
        label: trad.MAXIMUM_COLOR,
        propsName: "colorMaxValue",
        type: configurationType.COLOR_SELECTOR,
        defaultValue: "#fe151b",
      }
    case "maxFontSize":
      return {
        label: trad.MAX_FONT_SIZE,
        propsName: "maxFontSize",
        type: configurationType.INPUT,
        dataType: "number",
        useMinMax: true,
        min: 0,
        max: 100,
        defaultValue: 30,
      }
    case "useMarker":
      return {
        label: trad.USE_MARKER,
        propsName: "useMarker",
        type: configurationType.TOGGLE,
        defaultValue: true,
      }
    case "useMarkerCluster":
      return {
        label: trad.USE_MARKER_CLUSTER || "Activate marker clustering",
        propsName: "useMarkerCluster",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "themeGoogleMap":
      return {
        label: trad.THEME,
        propsName: "themeGoogleMap",
        type: configurationType.SELECT,
        defaultValue: "white",
        options: [
          {
            value: "standard",
            name: trad.STANDARD,
          },
          {
            value: "white",
            name: trad.BLANC,
          },
          {
            value: "grey",
            name: trad.GREY,
          },
          {
            value: "green",
            name: trad.VERT,
          },
          {
            value: "retro",
            name: trad.RETRO,
          },
          {
            value: "aubergine",
            name: trad.AUBERGINE,
          },
          {
            value: "night",
            name: trad.NIGHT,
          },
          {
            value: "black",
            name: trad.BLACK,
          },
        ],
      }
    case "centerGoogleMap":
      return {
        label: trad.LABEL, //add translation here
        propsName: "localisationCenter",
        type: configurationType.LOCATION_INPUT,
        dataType: "text",
        showIcon: false,
      }
    /******************** CATEGORY ZONE *********************/

    case "categoryColorText":
    case "categoryRadarColorText":
    case "categoryHistogramColorText":
    case "categoryTreeMapColorText":
      return {
        label: trad.COLOR_AND_TEXT,
        isCategory: true,
        inputs: ["colorSetThemeName", "colorMapper", "titleStyle", "titleAlignement"],
      }
    // Les jauges restent en dehors de la table valeur -> couleur : leur couleur vient de plages
    // de valeurs (`ranges`, cf. GaugeRangeConfigurator), pas d'une valeur de legende.
    case "categoryGaugeColorText":
      return {
        label: trad.COLOR_AND_TEXT,
        isCategory: true,
        inputs: ["colorSetThemeName", "titleStyle", "titleAlignement"],
      }
    case "categoryEvolutionColorText":
    case "categoryImageColorText":
    case "categoryDropdownColorText":
    case "categorCalendarColorText":
    case "categoryHeatMapColorText":
    case "categoryCloudWordsColorText":
      return {
        label: trad.COLOR_AND_TEXT,
        isCategory: true,
        inputs: ["titleStyle", "titleAlignement"],
      }
    case "categoryExportMenu":
    case "categoryTableExportMenu":
    case "categoryRadarExportMenu":
    case "categoryPieChartExportMenu":
    case "categoryHistogramExportMenu":
    case "categoryLineChartExportMenu":
    case "categoryMapExportMenu":
    case "categoryGaugeExportFullSize":
    case "categoryTreeMapExportMenu":
    case "categoryBubbleChartExportMenu":
    case "categoryCounterExportMenu":
      return {
        label: trad.EXPORT_AND_FULLSCREEN,
        isCategory: true,
        inputs: ["enableExportMenu", "enableFullScreen"],
      }
    case "categoryLegend":
    case "categoryRadarLegend":
    case "categoryPieChartLegend":
    case "categoryHistogramLegend":
    case "categoryGaugeLegend":
    case "categoryTreeMapLegend":
    case "categoryBubbleChartLegend":
      return {
        label: trad.LEGEND,
        isCategory: true,
        inputs: ["visibilityLegend", "legendPosition", "displayTypeLegendLabels"],
      }
    case "categoryHeatMapLegend":
      return {
        label: trad.LEGEND,
        isCategory: true,
        inputs: ["visibilityLegend", "legendPosition"],
      }
    case "categoryMapLegend":
      return {
        label: "Légende",
        isCategory: true,
        inputs: ["mapVisibilityLegend", "mapLegendLabel", "mapLegendLabelStyle"],
      }
    case "categoryMapZoom":
      return {
        label: "Zoom",
        isCategory: true,
        inputs: ["mapIsZoomable", "zoomButtons", "zoomAnimation"],
      }
    case "categoryImageImage":
      return {
        label: trad.IMAGE,
        isCategory: true,
        inputs: ["imageInput", "opacity", "opacityPercent", "blur"],
      }
    case "categoryGanttDisplay":
      return {
        label: trad.DISPLAY,
        isCategory: true,
        inputs: ["ganttSidebarWidthPercent", "ganttDurationUnit", "ganttExcludeWeekends"],
      }
    // Ces trois alias retombent volontairement sur « Fond & Forme du widget » : n'insérer
    // aucun case avec son propre return entre eux et `categoryWidgetShape`, sous peine de
    // priver compteur / image / texte libre de leur section fond et bordure.
    case "categoryImageWidgetShape":
    case "categoryBasicTextWidgetShape":
    case "categoryCounterWidgetShape":
    case "categoryWidgetShape":
      return {
        label: trad.WIDGET_SHAPE,
        isCategory: true,
        inputs: ["backgroundColor", "bordureStyle", "borderRadius"],
      }
    case "categoryBasicTextColorText":
      return {
        label: trad.COLOR_AND_TEXT,
        isCategory: true,
        inputs: ["titleStyle", "titleAlignement", "basicTextTextConfig", "basicTextTextAlignement"],
      }
    case "categoryCounterColorText":
      return {
        label: trad.COLOR_AND_TEXT,
        isCategory: true,
        inputs: [
          "valueStyle",
          "labelStyle",
          "titleStyle",
          "iconStyle",
          "themeStyle",
          "titleAlignement",
          "alignement",
          "iconPosition",
          "iconOpacity",
        ],
      }
    case "categoryCounterValues":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: ["numberDecimal", "decimalSeparator", "showSpaceForThousand"],
      }
    case "categoryTableColorText":
      return {
        label: trad.COLOR_AND_TEXT,
        isCategory: true,
        inputs: [
          "headBackgroundColor",
          "headFontSize",
          "headColor",
          "bodyEvenRowBackgroundColor",
          "bodyOddRowBackgroundColor",
          "titleStyle",
          "titleAlignement",
        ],
      }
    case "categoryTableGrid":
      return {
        label: trad.GRID,
        isCategory: true,
        inputs: [
          "freezeFirstColumn",
          "displayHeadCellSeparator",
          "displayBodyRowSeparator",
          "displayBodyCellSeparator",
        ],
      }
    case "categoryTableValues":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: ["numberDecimal", "showSpaceForThousand"],
      }
    case "categoryTableAdvancedStyle":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: [
          "enableFilters",
          "headCellJustifyContent",
          "bodyCellJustifyContent",
          "enableFooters",
          "enableCountRow",
          "footBackgroundColor",
          "footColor",
          "footCellAlignItems",
          "enablePagination",
          "nbRowsPerPage",
          "paginationColor",
        ],
      }
    case "categoryAgTableFeatures":
      return {
        label: trad.FEATURES,
        isCategory: true,
        inputs: [
          "resizableColumns",
          "freezeFirstColumn",
          "enableTooltipCell",
          "enableColumnsSumFooter",
          "enableFilters",
          "enablePagination",
          "nbRowsPerPage",
        ],
      }
    case "categoryAgTableAdvancedStyle":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: [
          "headBackgroundColor",
          "headColor",
          "headFontSize",
          "headCellJustifyContent",
          "bodyEvenRowBackgroundColor",
          "bodyOddRowBackgroundColor",
          "bodyTableAlignement",
        ],
      }
    case "categoryRadarAxis":
      return {
        label: trad.AXIS,
        isCategory: true,
        inputs: ["axisForceMinMax", "axisMax", "axisMin"],
      }
    case "categoryRadarValue":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: [
          "radarHideLabelIfPercentTooSmall",
          "radarValuePercentUnderWhichHideLabel",
          "numberDecimal",
          "decimalSeparator",
          "showSpaceForThousand",
        ],
      }
    case "categoryRadarAdvancedStyle":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: ["sizeBullet", "strokeWidthLine", "lineStyle", "fillOpacityCurve"],
      }
    case "categoryRedirectButtonColorText":
      return {
        label: trad.COLOR_AND_TEXT,
        isCategory: true,
        inputs: [
          "labelStyle",
          "alignement",
          "redirectButtonSelectIcon",
          "redirectButtonIconAlignement",
        ],
      }
    case "categoryRedirectButtonWidgetShape":
      return {
        label: trad.REDIRECT_BUTTON_SHAPE,
        isCategory: true,
        inputs: ["redirectButtonBackground", "redirectButtonBorderStyle", "borderRadius"],
      }
    case "categoryPieChartColorText":
      return {
        label: trad.COLOR_AND_TEXT,
        isCategory: true,
        inputs: ["colorSetThemeName", "colorMapper", "titleStyle", "titleAlignement"],
      }
    case "categoryPieChartValues":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: [
          "hideLabelIfPercentTooSmall",
          "valuePercentUnderWhichHideLabel",
          "numberDecimal",
          "decimalSeparator",
          "showSpaceForThousand",
          // "hideLabels",
          "hideCenteredValue",
          "titleCenterStyle",
          // "centeredValue",
        ],
      }
    case "categoryPieChartAdvancedStyle":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: [
          "innerRadius",
          "startAngle",
          "endAngle",
          "serieRadius",
          "borderActivation",
          "pieChartGaugeMode",
        ],
      }
    case "categoryDoublePieChartValues":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: [
          "hideLabelIfPercentTooSmall",
          "valuePercentUnderWhichHideLabel",
          "numberDecimal",
          "decimalSeparator",
          "showSpaceForThousand",
        ],
      }
    case "categoryDoublePieChartAdvancedStyle":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: ["startAngle", "endAngle", "serieRadius", "borderActivation"],
      }
    case "categoryPieChartCentralText":
      return {
        label: trad.CENTRAL_TEXT,
        isCategory: true,
        inputs: ["hideCenteredText", "centeredText", "centeredTextStyle"],
      }
    case "categoryPieChartExternalLabel":
      return {
        label: trad.EXTERNAL_LABEL,
        isCategory: true,
        inputs: [
          "hideExternalSerieLabel",
          "typeOfExternalLabel",
          "typeLabelText",
          "externalSerieLabelStyle",
          "externalSerieValueStyle",
        ],
      }
    case "categoryHistogramAxis":
      return {
        label: trad.AXIS,
        isCategory: true,
        inputs: [
          "titleAxeX",
          "titleAxeY",
          "displayTypeLabel",
          "rotationLabelAxesX",
          "axisStartZero",
          "integerValueAxis",
          "hideAxeXLabel",
          "hideAxeYLabel",
          "toogleMinMaxYAxis",
          "minYAxis",
          "maxYAxis",
        ],
      }
    case "categoryHistogramGrid":
      return {
        label: trad.GRID,
        isCategory: true,
        inputs: ["disabledGridAxesX", "disabledGridAxesY"],
      }
    case "categoryHistogramValues":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: [
          "minAxesYtoZero",
          "hideLabelIfPercentTooSmall",
          "valuePercentUnderWhichHideLabel",
          "hideLabels",
          "showStackTotal",
          "stackTotalColor",
          "stackTotalFontSize",
          "numberDecimal",
          "decimalSeparator",
          "showSpaceForThousand",
        ],
      }
    case "categoryHistogramAdvancedStyle":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: [
          "columnCornerRadiusTopLeft",
          "columnCornerRadiusTopRight",
          "columnCornerRadiusBottomLeft",
          "columnCornerRadiusBottomRight",
          "columnsWidthPercent",
        ],
      }
    case "categoryLineChartColorText":
      return {
        label: trad.COLOR_AND_TEXT,
        isCategory: true,
        inputs: ["colorSetThemeName", "colorMapper", "titleStyle", "titleAlignement"],
      }
    case "categoryLineChartAxis":
      return {
        label: trad.AXIS,
        isCategory: true,
        inputs: [
          "titleAxeX",
          "titleAxeY",
          "displayTypeLabel",
          "rotationLabelAxesX",
          "axisStartZero",
          "integerValueAxis",
          "toogleMinMaxYAxis",
          "minYAxis",
          "maxYAxis",
        ],
      }
    case "categoryLineChartLegend":
      return {
        label: trad.LEGEND,
        isCategory: true,
        inputs: ["visibilityLegend", "legendPosition", "displayTypeLegendLabels"],
      }
    case "categoryLineChartGrid":
      return {
        label: trad.GRID,
        isCategory: true,
        inputs: ["disabledGridAxesX", "disabledGridAxesY"],
      }
    case "categoryLineChartAdvancedStyle":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: ["sizeBullet", "strokeWidthLine", "lineStyle", "formCurve", "fillOpacityCurve"],
      }
    case "categoryLineChartValues":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: ["numberDecimal", "decimalSeparator", "showSpaceForThousand"],
      }
    case "categoryDropdownColorText":
      return {
        label: trad.COLOR_AND_TEXT,
        isCategory: true,
        inputs: ["titleStyle", "titleAlignement"],
      }
    case "categoryStackedAreaAdvancedStyle":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: ["sizeBullet", "strokeWidthLine", "lineStyle", "fillOpacityCurve"],
      }
    case "categoryDropdownWidgetShape":
      return {
        label: trad.WIDGET_SHAPE,
        isCategory: true,
        inputs: ["defaultColor", "dropdownBordureStyle", "dropdownBorderRadius"],
      }
    case "categoryRangeFilterWidgetShape":
      return {
        label: trad.WIDGET_SHAPE,
        isCategory: true,
        inputs: ["defaultColor", "sliderColor", "dropdownBordureStyle", "dropdownBorderRadius"],
      }
    case "categoryCalendarWidgetShape":
      return {
        label: trad.WIDGET_SHAPE,
        isCategory: true,
        inputs: ["defaultColor", "calendarBordureStyle", "calendarBorderRadius"],
      }
    case "categorySearchBarWidgetShape":
      return {
        label: trad.WIDGET_SHAPE,
        isCategory: true,
        inputs: ["defaultColor", "dropdownBordureStyle", "dropdownBorderRadius"],
      }
    case "categoryDropdownBehavior":
      return {
        label: "Comportement",
        isCategory: true,
        inputs: ["allowEmptyOption"],
      }
    case "allowEmptyOption":
      return {
        label: "Proposer la valeur « Vide »",
        propsName: "allowEmptyOption",
        type: configurationType.TOGGLE,
        // ⚠️ Faux par défaut, et il doit le rester : les valeurs vides sont retirées des options
        // depuis toujours. Les rendre sélectionnables partout changerait le comportement de
        // dashboards que personne n'a demandé de modifier.
        defaultValue: false,
      }
    case "categorySearchBarBehavior":
      return {
        label: "Comportement",
        isCategory: true,
        inputs: ["matchMode", "caseSensitive", "showSuggestions", "timingBeforeSelectActivation"],
      }
    case "matchMode":
      return {
        label: "Mode de correspondance",
        propsName: "matchMode",
        type: configurationType.SELECT,
        defaultValue: "contains",
        options: [
          { value: "contains", name: "Contient" },
          { value: "startsWith", name: "Commence par" },
          { value: "exact", name: "Exact" },
        ],
      }
    case "caseSensitive":
      return {
        label: "Sensible à la casse",
        propsName: "caseSensitive",
        type: configurationType.TOGGLE,
        defaultValue: false,
      }
    case "showSuggestions":
      return {
        label: "Afficher les suggestions",
        propsName: "showSuggestions",
        type: configurationType.TOGGLE,
        defaultValue: true,
      }
    case "categoryMapColorText":
      return {
        label: trad.COLOR_AND_TEXT,
        isCategory: true,
        inputs: [
          "colorSetThemeName",
          "titleStyle",
          "titleAlignement",
          "mapBulletColor",
          "mapTooltipColor",
        ],
      }
    case "categoryMapValue":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: ["numberDecimal", "decimalSeparator", "showSpaceForThousand"],
      }
    case "categoryMapAdvancedStyle":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: ["mapIsZoomable", "zoomButtons", "zoomAnimation", "mapIsDraggable", "mapSwapVue"],
      }
    case "categoryGaugeValues":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: [
          "showAxisLabel",
          "numberDecimal",
          "decimalSeparator",
          "showSpaceForThousand",
          "showCenteredValue",
          "customCenteredValue",
          "axisForceMinMax",
          "axisMin",
          "axisMax",
          "isGradientRange",
          "ranges",
        ],
      }
    case "categoryGaugeAdvancedStyle":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: [
          "innerRadius",
          "startAngle",
          "endAngle",
          "showGrid",
          "minGridDistance",
          "showOnlyMinMaxLabel",
          "defaultColor",
          "showClockHand",
        ],
      }
    case "categoryProgressBarLabel":
      return {
        label: trad.LABEL,
        isCategory: true,
        inputs: [
          "showLabel",
          "labelPosition",
          "uniqueColor",
          "uniqueColorValue",
          "labelStyleConditional",
        ],
      }
    case "categoryProgressBarLegend":
      return {
        label: trad.LEGEND,
        isCategory: true,
        inputs: ["visibilityLegend", "legendPosition"],
      }
    case "categoryProgressBarValue":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: [
          "hideValues",
          "typeValue",
          "progressBarValueStyleConditional",
          "showSpaceForThousandProgressBar",
        ],
      }
    case "categoryProgressBarExportMenu":
      return {
        label: trad.EXPORT_AND_FULLSCREEN,
        isCategory: true,
        inputs: ["enableExportMenu", "enableFullScreen"],
      }
    case "categoryTooltip":
      return {
        label: trad.TOOLTIP,
        isCategory: true,
        inputs: ["tooltipActivation", "tooltipValueType"],
      }
    case "categoryProgressBar":
      return {
        label: trad.BAR,
        isCategory: true,
        inputs: [
          "displayInMultipleProgressBar",
          "progressBarNumber",
          "progressBarHeight",
          "progressBarRadius",
          "colorSetThemeName",
        ],
      }
    case "categoryTreeMapValue":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: [
          "enableZoom",
          "enableNavigationBar",
          "maxLevelInSameTime",
          "initialViewText",
          "hideLabelIfPercentTooSmall",
          "valuePercentUnderWhichHideLabel",
          "numberDecimal",
          "decimalSeparator",
          "showSpaceForThousand",
        ],
      }
    case "categoryTreeMapAdvancedStyle":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: [
          "bulletLabelType",
          "bulletLabelStyle",
          "bulletValueStyle",
          "columnCornerRadiusTopLeft",
          "columnCornerRadiusTopRight",
          "columnCornerRadiusBottomLeft",
          "columnCornerRadiusBottomRight",
        ],
      }
    case "categoryMultiGaugeValue":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: [
          "numberDecimal",
          "decimalSeparator",
          "showSpaceForThousand",
          "hideValues",
          "hideLabelIfPercentTooSmall",
          "valuePercentUnderWhichHideLabel",
          "hideAxisValues",
          "hideCentralValue",
          "typeOfCentralValue",
          "customLabelInput",
          "valueTitleCenterStyle",
          "subTitleCenterStyle",
          "customLabelCenterStyle",
        ],
      }
    case "categoryMultiGaugeAdvancedStyle":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: ["innerGaugeRadius", "columnCornerRadius", "typeOfMaxValue"],
      }
    case "categoryEvolutionValue":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: [
          "numberDecimal",
          "decimalSeparator",
          "showSpaceForThousand",
          "percentOrDelta",
          "customLabel",
          "customLabelStyle",
        ],
      }
    case "categoryEvolutionAdvancedValue":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: [
          "evolutionThemeStyle",
          "iconPositiveSelected",
          "iconPositiveStyle",
          "iconNegativeSelected",
          "iconNegativeStyle",
          "iconNeutralSelected",
          "iconNeutralStyle",
          "valuePositiveStyle",
          "valueNegativeStyle",
          "valueNeutralStyle",
          // "comparisonStyle",
        ],
      }
    case "categoryBubbleChartColorText":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: ["titleStyle", "titleAlignement"],
      }
    case "categoryBubbleChartAxis":
      return {
        label: trad.AXIS,
        isCategory: true,
        inputs: [
          "titleAxeX",
          "titleAxeY",
          "displayTypeLabel",
          "axisStartZero",
          "hideAxeXLabel",
          "hideAxeYLabel",
          "toogleMinMaxYAxis",
          "minYAxis",
          "maxYAxis",
        ],
      }
    case "categoryBubbleChartValues":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: ["numberDecimal", "decimalSeparator", "showSpaceForThousand"],
      }
    case "categoryBubbleChartGrid":
      return {
        label: trad.GRID,
        isCategory: true,
        inputs: ["disabledGridAxesX", "disabledGridAxesY"],
      }
    case "categoryBubbleChartAdvancedStyle":
      return {
        label: trad.ADVANCED_STYLE,
        isCategory: true,
        inputs: ["defaultColor"],
      }
    case "categoryHeatMapValue":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: [
          "colorMinValue",
          "colorMaxValue",
          "numberDecimal",
          "decimalSeparator",
          "showSpaceForThousand",
        ],
      }
    case "categoryHeatMapAxis":
      return {
        label: trad.AXIS,
        isCategory: true,
        inputs: ["titleAxeX", "titleAxeY"],
      }
    case "categoryCloudWordsValue":
      return {
        label: trad.VALUE,
        isCategory: true,
        inputs: ["maxFontSize", "colorMinValue", "colorMaxValue"],
      }
    case "lastSampleReferentialId":
      return {
        label: trad.LAST_SAMPLE_SELECT_REFERENTIAL || "Référentiel",
        propsName: "lastSampleReferentialId",
        type: configurationType.REFERENTIAL_SIMPLE_SELECT,
        defaultValue: "",
      }
    case "lastSampleProperties":
      return {
        label: trad.LAST_SAMPLE_SELECT_PROPERTIES || "Propriétés à afficher",
        propsName: "lastSampleProperties",
        type: configurationType.REFERENTIAL_PROPERTIES_SELECT,
        defaultValue: [],
      }
    default:
      return {}
  }
}

const getWidgetDefaultPropsFromConfig = (widgetType, langageId, options) => {
  var listOfConfigName = getAvailableWidgetConfiguration(widgetType)
  var objectToReturn = {}

  listOfConfigName.forEach(configName => {
    var configDetail = getConfigurationDetail(configName, langageId, options)
    if (configDetail?.isCategory) {
      configDetail?.inputs.map(inputName => {
        const configCategory = getConfigurationDetail(inputName, langageId, options)
        if (configCategory?.defaultValue !== undefined) {
          const { propsName, defaultValue } = configCategory
          objectToReturn[propsName] = defaultValue
        }
      })
    } else if (configDetail?.defaultValue !== undefined) {
      const { propsName, defaultValue } = configDetail
      objectToReturn[propsName] = defaultValue
    }
  })
  return objectToReturn
}

/**
 * @description Get widget DEFAULT PROPS
 */
export const getWidgetDefaultProps = (widgetType, langageId = 1, options) => {
  var defaultProps = getWidgetDefaultPropsFromConfig(widgetType, langageId, options)

  const trad = getTranslation(langageId) || {}

  switch (widgetType) {
    case "pieChart":
      return {
        ...defaultProps,
        colorSetTheme: options.colorPalette[options.defaultColorPalette],
        colorSetThemeName: options.defaultColorPalette,
        numberDecimal: 2,
        borderActivation: false,
        externalValueWeight: "normal",
        externalValueColor: "#000",
        externalValueSize: 1,
        showSpaceForThousand: true,
      }
    case "calendar":
      return {
        ...defaultProps,
        placeholder: "date",
        activeBorder: false,
        calendarBorderColor: "#000",
        calendarBorderSize: "1px",
        calendarBorderStyle: "solid",
      }
    case "dropdownList":
      return {
        ...defaultProps,
        placeholder: "Selectionner dans la liste",
        filterType: "singleSelect",
        timingBeforeSelectActivation: 1000,
        colorSetThemeName: options.defaultColorPalette,
        colorSetTheme: options.colorPalette[options.defaultColorPalette],
        activeBorder: false,
        sortingType: "default",
        dropdownBorderColor: "#000",
        dropdownBorderSize: "1px",
        dropdownBorderStyle: "solid",
      }
    case "rangeFilter":
      return {
        ...defaultProps,
        placeholder: trad?.SELECT_A_RANGE,
        activeBorder: false,
        dropdownBorderColor: "#000",
        dropdownBorderSize: "1px",
        dropdownBorderStyle: "solid",
        sliderColor: options?.primaryActionColor,
        defaultColor: options?.primaryActionColor,
      }
    case "searchBar":
      return {
        ...defaultProps,
        placeholder: "Rechercher...",
        matchMode: "contains",
        caseSensitive: false,
        showSuggestions: true,
        timingBeforeSelectActivation: 500,
        activeBorder: false,
        dropdownBorderColor: "#000",
        dropdownBorderSize: "1px",
        dropdownBorderStyle: "solid",
        dropdownBorderRadius: "5px",
        defaultColor: options?.primaryActionColor,
      }
    case "hierarchicalFilter":
      return {
        ...defaultProps,
        placeholder: "Filtrer par hiérarchie",
        parentSide: "left",
        displayMode: "dropdown",
        activeBorder: false,
        dropdownBorderColor: "#000",
        dropdownBorderSize: "1px",
        dropdownBorderStyle: "solid",
        dropdownBorderRadius: "5px",
        defaultColor: options?.primaryActionColor,
      }
    case "stackedArea":
      return {
        ...defaultProps,
        colorSetThemeName: options.defaultColorPalette,
        colorSetTheme: options.colorPalette[options.defaultColorPalette],
        stackedLines: true,
        extraMinAxesY: 0,
      }
    case "counter":
      return {
        activeBackground: true,
        activeBorder: false,
        activeRadius: true,
        backgroundColor: "#ffffff",
        borderRadius: "10px",
        fontAlignement: "center",
        fontColor: "#000000",
        fontSize: "2.6rem",
        fontWeight: "bold",
        labelColor: "#000000",
        labelSize: "1.4rem",
        labelWeight: "normal",
        themeStyle: "defaultStyle",
        colorSetThemeName: options.defaultColorPalette,
        colorSetTheme: options.colorPalette[options.defaultColorPalette],
        numberDecimal: 2,
        showSpaceForThousand: true,
      }
    case "gaugeChart":
      return {
        ...defaultProps,
        startAngle: -180,
        endAngle: -0,
        colorSetThemeName: options.defaultColorPalette,
        colorSetTheme: options.colorPalette[options.defaultColorPalette],
        showSpaceForThousand: true,
        valueAxisMin: 0,
        valueAxisMax: 100,
      }
    case "radarChart":
      return {
        ...defaultProps,
        visibilityLegend: true,
        colorSetThemeName: options.defaultColorPalette,
        colorSetTheme: options.colorPalette[options.defaultColorPalette],
        axisForceMinMax: false,
        axisMin: 0,
        numberDecimal: 2,
        showSpaceForThousand: true,
      }
    case "mapping":
      return {
        ...defaultProps,
        primaryActionColor: "#787878",
        bulletBorderSize: "1px",
        zoomAnimation: false,
        zoomButtons: false,
        withChoicePath: false,
        mapVue: "bckgrColor",
        categoryData: "",
        scaleDuration: 0.5,
        isDraggable: true,
        visibilityLegend: false,
        tooltipColor: "#787878",
        bulletColor: "#787878",
        scaleValue: 1.5,
        legendLabelWeight: "",
        legendLabelColor: "",
        legendLabelSize: "",
        legendLabel: "",
        valueData: "",
        mapChoice: "",
        isZoomable: false,
        bulletView: false,
        dataChart: [],
      }
    case "mappingFilter":
      return {
        ...defaultProps,
        primaryActionColor: "#787878",
        bulletBorderSize: "1px",
        zoomAnimation: false,
        zoomButtons: false,
        withChoicePath: false,
        mapVue: "filter",
        categoryData: "",
        scaleDuration: 0.5,
        isDraggable: true,
        visibilityLegend: false,
        tooltipColor: "#787878",
        bulletColor: "#787878",
        scaleValue: 1.5,
        valueData: "",
        mapChoice: "",
        isZoomable: false,
        bulletView: false,
        dataChart: [],
      }
    case "basicText":
      return {
        ...defaultProps,
        activeBackground: true,
        activeBorder: false,
        activeRadius: true,
        titleColor: "#000000",
        titleSize: "1rem",
        titleWeight: "bolder",
        backgroundColor: "#fff",
        basicTextTextAlignement: "left",
        basicTextTextColor: "#000",
        basicTextTextSize: "1rem",
        borderRadius: "5px",
        borderSize: "1px",
        bordureStyle: "#000",
        textAreaValue: "",
      }
    case "redirectButton":
      return {
        ...defaultProps,
        redirectButtonBackgroundColor: "#FFFFFF",
        redirectButtonIconAlignement: "right",
        redirectButtonBorderActive: false,
        redirectButtonBorderColor: "#000",
        redirectButtonBorderStyle: "solid",
        redirectButtonBorderSize: "1px",
        redirectButtonSelectIcon: "",
        redirectButtonIsPageUrl: false,
        redirectButtonPageUrl: "",
        redirectButtonIsUrl: true,
        redirectButtonReferentiel: "",
        redirectButtonIsReferentiel: false,
        fontAlignement: "center",
        redirectButtonUrl: "",
        labelWeight: "bold",
        labelColor: "#000000",
        labelSize: "1.2rem",
        activeRadius: false,
        borderRadius: "5px",
        label: "ACTION",
      }
    case "progressBar":
      return {
        ...defaultProps,
        colorSetTheme: options.colorPalette[options.defaultColorPalette],
        progressBarSecondLabelWeight: "bold",
        progressBarSecondLabelColor: "#666",
        progressBarSecondLabelSize: "2rem",
        progressBarFirstLabelWeight: "bold",
        progressBarFirstLabelColor: "#000",
        progressBarFirstLabelSize: "2rem",
        tooltipValueType: "text_and_value",
        tooltipActivation: false,
        legendPosition: "bottom",
        visibilityLegend: false,
        labelPosition: "bottom",
        labelWeight: "normal",
        progressBarRadius: 20,
        progressBarHeight: 15,
        disableLabel: false,
        uniqueColor: false,
        labelColor: "#000",
        labelSize: "1rem",
        dataChart: [],
        categoryData: "",
        valueData: [],
        hideValues: true,
        labelWeight: "normal",
        labelSize: "1rem",
      }
    case "image":
      return {
        ...defaultProps,
        urlImage: "",
        tempUrlImage: "",
        nbOfChanges: 0,
        isTempImage: false,
        imageFile: "",

        opacity: false,
        opacityPercent: 50,
        blur: false,

        activeBackground: false,
        backgroundColor: "#fff",
      }
    case "table":
      return {
        ...defaultProps,
        showSpaceForThousand: true,
      }
    case "ag_table":
      return {
        ...defaultProps,
        headBackgroundColor: "#F8F8F8",
        headColor: "#000000",
        headFontSize: "0.8rem",
        bodyEvenRowBackgroundColor: "#FFFFFF",
        bodyOddRowBackgroundColor: "#FCFCFC",
        showSpaceForThousand: true,
      }
    case "treeMap":
      return {
        enableZoom: true,
        hideLabelIfPercentTooSmall: false,
        valuePercentUnderWhichHideLabel: 100,
        maxLevelInSameTime: 1,
        initialViewText: "",
        bulletLabelType: "default",
        bulletLabelColor: "#FFFFFF",
        colorSetThemeName: options.defaultColorPalette,
        colorSetTheme: options.colorPalette[options.defaultColorPalette],
        numberDecimal: 2,
        columnCornerRadiusTopLeft: 0,
        columnCornerRadiusTopRight: 0,
        columnCornerRadiusBottomLeft: 0,
        columnCornerRadiusBottomRight: 0,
        showSpaceForThousand: true,
      }
    case "multiGauge":
      return {
        ...defaultProps,
        colorSetTheme: options.colorPalette[options.defaultColorPalette],
        endAngle: 270,
        innerRadius: 20,
        columnCornerRadius: 10,
        numberDecimal: 2,
        showSpaceForThousand: true,
        hideLabelIfPercentTooSmall: false,
        hideCentralValue: false,
        typeOfCentralValue: "value_and_percent",
      }
    case "cloudWords":
      return {
        ...defaultProps,
        colorMinValue: "#707070",
        colorMaxValue: "#000000",
      }
    default:
      return {
        ...defaultProps,
        colorSetThemeName: options.defaultColorPalette,
        colorSetTheme: options.colorPalette[options.defaultColorPalette],
        numberDecimal: 2,
      }
  }
}

/**
 * @description Get widget DEFAULT SIZE in layout
 */
export const getDefaultWidgetDimensionObj = widgetType => {
  switch (widgetType) {
    case "dropdownList":
      return {
        w: 3,
        h: 2,
      }
    case "rangeFilter":
    case "searchBar":
      return {
        w: 3,
        h: 2,
      }
    case "hierarchicalFilter":
      return {
        w: 3,
        h: 4,
      }
    case "counter":
    case "evolutionWidget":
      return {
        w: 3,
        h: 3,
      }
    case "calendar":
      return {
        w: 3,
        h: 2,
      }
    case "redirectButton":
      return {
        w: 3,
        h: 2,
      }
    case "basicText":
      return {
        w: 4,
        h: 3,
      }
    case "mapping":
    case "mappingFilter":
      return {
        w: 6,
        h: 8,
      }
    case "image":
      return {
        w: 3,
        h: 5,
      }
    case "progressBar":
      return {
        w: 6,
        h: 3,
      }
    default:
      return {
        w: 6,
        h: 6,
      }
  }
}

export const getWidgetLayout = (page, widgetId, options) => {
  var breakpoint = "lg"
  if (options.hasOwnProperty("breakpoint")) breakpoint = options.breakpoint
  var widgetLayout = undefined
  if (page && widgetId) {
    widgetLayout = page?.layouts?.[breakpoint]?.find(widget => widget.i === widgetId)
  }
  var defaultResponse = {
    x: 0,
    y: 1,
    w: 2,
    h: 3,
    i: "defaultId",
  }
  return widgetLayout ? widgetLayout : defaultResponse
}
